import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../components/Sidebar";
import Table from "../components/Table";
import OrderDetailsCommentPopup from '../components/OrderDetailsCommentPopup';
import GetInventory from "../components/GetInventory";
import Remarks from "../components/Remarks";
import "../i18n";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/components.css";
import GetProducts from "../components/GetProducts";
import QuantityController from "../components/QuantityController";
import GetCustomers from "../components/GetCustomers";
import GetBranches from "../components/GetBranches";
import { useAuth } from "../context/AuthContext";
import RbacManager from "../utilities/rbac";
import formatDate from "../utilities/dateFormatter";
import ApprovalDialog from "../components/ApprovalDialog";
import GetPaymentMethods from "../components/GetPaymentMethods";
import Dropdown from "../components/DropDown";
import Swal from "sweetalert2";
import LoadingSpinner from "../components/LoadingSpinner";
import axios from "axios";
import Constants from "../constants";
import PdfPopupViewer from "../components/PdfPopupViewer";
import { convertToTimezone, TIMEZONES } from "../utilities/convertToTimezone";
import SearchableDropdown from "../components/SearchableDropdown";
import { Box, Button, Typography, Tooltip, Chip } from "@mui/material";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

import {
  DataGrid,
  GridFooterContainer,
  GridPagination,
  useGridApiRef,
} from "@mui/x-data-grid";
import { set } from "date-fns";

const defaultOrder = {
  id: "",
  erpCustId: "",
  erpBranchId: "",
  orderBy: "",
  erp: "",
  entity: "",
  category: "",
  paymentMethod: "",
  totalAmount: "",
  paymentPercentage: "",
  paidAmount: "",
  deliveryCharges: "",
  branchRegion: "",
  expectedDeliveryDate: "",
  createdAt: "",
  updatedAt: "",
  status: "",
  driver: "",
  vehicleNumber: "",
  erpWarehouseId: "",
  warehouseNameEn: "",
  warehouseNameAr: "",
  images: [],
  products: [],
  customerUnblockedUntil: "",
};

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const APP_BLOB_URL = process.env.REACT_APP_BLOB_STORAGE_URL;

// Helper function to convert payment percentage from decimal to dropdown format
const convertPaymentPercentageToDropdown = (paymentPercentage) => {
  if (!paymentPercentage) return "";

  // Convert string to number for comparison
  const numValue = parseFloat(paymentPercentage);

  if (numValue === 100 || numValue === 100.0) {
    return "100%";
  } else if (numValue === 30 || numValue === 30.0) {
    return "30%";
  }

  // If it's already in percentage format, return as is
  if (
    typeof paymentPercentage === "string" &&
    paymentPercentage.includes("%")
  ) {
    return paymentPercentage;
  }

  return "";
};

// Helper function to safely handle date values for API requests
const safeDateValue = (dateValue) => {
  if (
    !dateValue ||
    (typeof dateValue === "string" && dateValue.trim() === "")
  ) {
    return null;
  }
  return dateValue;
};

function OrderDetails() {
  const gridApiRef = useGridApiRef();
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { user, token } = useAuth(); // Get form mode from location state (add, edit, view)
  const formMode = location.state?.mode || "view";
  const orderFromNav = location.state?.order || {};
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  console.log("Order details from nav", orderFromNav);
  const salesOrderLinesFromNav =
    orderFromNav &&
      orderFromNav.salesOrderLines &&
      Array.isArray(orderFromNav.salesOrderLines)
      ? orderFromNav.salesOrderLines
      : [];
  const fromApproval = location.state?.fromApproval;
  const wfid = location.state?.wfid || null;
  const approvalHistory = location.state?.approvalHistory || []; // Initialize form data
  const [formData, setFormData] = useState({
    ...defaultOrder,
    ...orderFromNav,
    id: orderFromNav.id || "",
    paymentPercentage:
      convertPaymentPercentageToDropdown(orderFromNav.paymentPercentage) ||
      orderFromNav.paymentPercentage ||
      "",
    products: [],
  });
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    console.log("isMobile", isMobile);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // Effect to keep orderId in sync with formData.id
  useEffect(() => {
    setOrderId(formData.id || "");
  }, [formData.id]);

  useEffect(() => {
    if (fromApproval && orderFromNav.sampleOrder) {
      setSampleMode(true);
    }
  }, [fromApproval, orderFromNav.sampleOrder]);

  // State variables
  const [loading, setLoading] = useState(true);
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [cancelling, setCancelling] = useState(false);
  const [error, setError] = useState(null);
  const [showInventory, setShowInventory] = useState(false);
  const [showRemarks, setShowRemarks] = useState(false);
  const [isCommentPanelOpen, setIsCommentPanelOpen] = useState(false);
  const [showProductPopup, setShowProductPopup] = useState(false);
  const [orderId, setOrderId] = useState(orderFromNav.id || "");
  const [showCustomerPopup, setShowCustomerPopup] = useState(false);
  const [showBranchPopup, setShowBranchPopup] = useState(false);
  const [popupImage, setPopupImage] = useState(null);
  const [nextOrderId, setNextOrderId] = useState("");
  const [saving, setSaving] = useState(false);
  const [checkedSave, setCheckedSave] = useState(false);
  const [isEditMode, setIsEditMode] = useState(formMode === "edit"); // Determine edit mode from formMode
  const [originalProducts, setOriginalProducts] = useState([]); // Track original products for comparison
  const [isApprovalDialogOpen, setIsApprovalDialogOpen] = useState(false);
  const [approvalAction, setApprovalAction] = useState(null);
  const [InventoryData, setInventoryData] = useState([]);
  const [InventoryLoading, setInventoryLoading] = useState(false);
  const [productName, setProductName] = useState("");
  const [sampleMode, setSampleMode] = useState(false);
  const [companyType, setCompanyType] = useState("");
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [pendingSaveAction, setPendingSaveAction] = useState(null); // Remove categoryOptions/products fetching and getFilteredVmcoCategories
  const [showModal, setShowModal] = useState(false);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [deliveryImages, setDeliveryImages] = useState([]);
  const [loadingProductId, setLoadingProductId] = useState(null);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [warehousesLoading, setWarehousesLoading] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState(i18n.language === 'ar' ? formData.warehouseNameAr : formData.warehouseNameEn);
  const [editingDiscount, setEditingDiscount] = useState({});
  const [pricingPolicyEnOptions, setPricingPolicyEnOptions] = useState([]);
  const [pricingPolicyArOptions, setPricingPolicyArOptions] = useState([]);
  const truncateTo2 = (value) => Math.floor(Number(value || 0) * 100) / 100;
  const roundTo2 = (value) => Math.round((Number(value || 0) + Number.EPSILON) * 100) / 100;
  //for Handle Save duplication prevention
  const isProcessingRef = useRef(false);
  // Use VMCO categories from constants
  const VMCO_CATEGORIES = [
    Constants.CATEGORY.VMCO_MACHINES,
    Constants.CATEGORY.VMCO_CONSUMABLES,
  ];

  const SHC_CATEGORIES = [
    Constants.CATEGORY.SHC_FRESH,
    Constants.CATEGORY.SHC_FROZEN,
      Constants.CATEGORY.SHC_SCHOOL,
    
  ];

  const paymentPercentageOptions = [
    { label: "100%", value: "100%" },
    { label: "30%", value: "30%" },
  ];

  useEffect(() => {
    const fetchWarehouseOptions = async () => {
      if (!fromApproval) return;

      setWarehousesLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/warehouses?page=1&pageSize=100`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch warehouses');
        }

        const result = await response.json();

        if (result.status === 'Ok' && result.data && Array.isArray(result.data)) {
          const formattedOptions = result?.data?.map(warehouse => ({
            name: i18n.language === 'ar' ? warehouse.warehouseNameAr : warehouse.warehouseNameEn,
            erpWarehouseId: warehouse.erpWarehouseId,
            warehouseNameEn: warehouse.warehouseNameEn,
            warehouseNameAr: warehouse.warehouseNameAr
          }));
          setWarehouseOptions(formattedOptions);
        } else {
          console.warn('Unexpected warehouse response format:', result);
          setWarehouseOptions([]);
        }
      } catch (error) {
        console.error('Error fetching warehouse options:', error);
        setWarehouseOptions([]);
      } finally {
        setWarehousesLoading(false);
      }
    };

    fetchWarehouseOptions();
  }, [fromApproval, token, i18n.language]);

  // Helper function to derive category from entity and product flags
  const deriveCategoryFromOrder = (entity, isMachine, isFresh) => {
    if (!entity) return '';

    if (entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase()) {
      return isMachine === true ? Constants.CATEGORY.VMCO_MACHINES : Constants.CATEGORY.VMCO_CONSUMABLES;
    } else if (entity.toLowerCase() === Constants.ENTITY.SHC.toLowerCase()) {
      return isFresh === true ? Constants.CATEGORY.SHC_FRESH : Constants.CATEGORY.SHC_FROZEN;
    }
    return '';
  };

  const handleWarehouseChange = (e) => {
    const selectedWarehouseName = e.target.value;
    if (!selectedWarehouseName) {
      setFormData(prev => ({
        ...prev,
        warehouse: null,
        erpWarehouseId: null,
        warehouseNameEn: null,
        warehouseNameAr: null,
      }));
      setSelectedWarehouse('');
      return;
    }

    // Find the selected warehouse object using the name
    const selectedWarehouse = warehouseOptions.find(
      warehouse => warehouse.name === selectedWarehouseName
    );

    console.log('Found warehouse:', selectedWarehouse);

    if (selectedWarehouse) {
      setFormData(prev => ({
        ...prev,
        warehouse: selectedWarehouse.erpWarehouseId,
        erpWarehouseId: selectedWarehouse.erpWarehouseId,
        warehouseNameEn: selectedWarehouse.warehouseNameEn,
        warehouseNameAr: selectedWarehouse.warehouseNameAr,
      }));

      // Update the selected warehouse display value
      setSelectedWarehouse(selectedWarehouse.name);
    }
  };

  useEffect(() => {
    if (formData.warehouseNameEn || formData.warehouseNameAr) {
      setSelectedWarehouse(i18n.language === 'ar' ? formData.warehouseNameAr : formData.warehouseNameEn);
    }
  }, [i18n.language, formData.warehouseNameEn, formData.warehouseNameAr]);

  useEffect(() => {
    if (formMode === "add") return;

    if (salesOrderLinesFromNav && Array.isArray(salesOrderLinesFromNav) && salesOrderLinesFromNav.length > 0) {
      console.log("Using pre-fetched sales order lines", salesOrderLinesFromNav.length);

      const processedProducts = salesOrderLinesFromNav.map(product => ({
        ...product,
        id: product.productId || product.id,
        productName: product.productName || product.productname || product.erpprodid,
        isMachine: product.isMachine,
        isFresh: product.isFresh,
        quantity: product.quantity,
        imageUrl: product.images[0] || ""
      }));

      // Derive category from orderFromNav entity and flags
      const derivedCategory = deriveCategoryFromOrder(
        orderFromNav.entity,
        orderFromNav.isMachine,
        orderFromNav.isFresh
      );

      setFormData(prev => ({
        ...prev,
        products: processedProducts,
        category: derivedCategory, // Set the derived category
      }));

      setOriginalProducts(processedProducts);
      console.log("Successfully loaded pre-fetched sales order lines", processedProducts);
      return;
    }

    const fetchOrderProducts = async () => {
      if (!orderFromNav.id) {
        console.log("No order ID available, skipping sales order lines fetch");
        return;
      }

      console.log(
        "Fetching sales order lines from API for order ID:",
        orderFromNav.id
      );
      try {
        const params = new URLSearchParams({
          page: 1,
          pageSize: 10000,
          search: "",
          sortBy: "id",
          sortOrder: "asc",
          filters: JSON.stringify({ order_id: orderFromNav.id }),
        });

        const url = `${API_BASE_URL}/sales-order-lines/pagination?${params.toString()}`;
        console.log("Fetching order products from URL:", url);
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("API did not return JSON. Check API URL and server.");
        }

        const result = await response.json();
        console.log("Sales order lines API response:", result);

        if (
          result.status === "Ok" &&
          result.data &&
          Array.isArray(result.data.data)
        ) {
          // Map the product data to ensure we use productName instead of erpProdId
          const processedProducts = result.data.data.map((product) => ({
            ...product,
            id: product.productId,
            productName:
              product.productName ||
              product.product_name ||
              product.erp_prod_id,
            isMachine: product.isMachine,
            isFresh: product.isFresh, // Add isFresh field if present
            quantity: product.quantity,
            imageUrl: product.images[0] || ""
          }));

          console.log("Processed products from API:", processedProducts);

          setFormData((prev) => ({
            ...prev,
            products: processedProducts,
          }));

          // Store the original product list for comparison when saving
          setOriginalProducts(processedProducts);
          console.log(
            "Successfully loaded sales order lines from API:",
            processedProducts.length,
            "items"
          );
        } else {
          console.warn(
            "No sales order lines found in API response or invalid response structure"
          );
          // Set empty products array if no data found
          setFormData((prev) => ({
            ...prev,
            products: [],
          }));
          setOriginalProducts([]);
        }
      } catch (err) {
        console.error("Error fetching sales order lines:", err);
        setError(err.message);
        // Set empty products array on error
        setFormData((prev) => ({
          ...prev,
          products: [],
        }));
        setOriginalProducts([]);
      }
    };
    fetchOrderProducts();
    // eslint-disable-next-line
  }, [orderFromNav.id, formMode, salesOrderLinesFromNav?.length]);

  // 🔥 REAL-TIME TOTAL CALCULATION (with BREAKDOWN)
  useEffect(() => {
    if (sampleMode) {
      setFormData(prev => ({
        ...prev,
        totalAmount: "0.00"
      }));
      return;
    }

    if (!Array.isArray(formData.products) || formData.products.length === 0) {
      setFormData(prev => ({
        ...prev,
        totalAmount: "0.00"
      }));
      return;
    }

    // 📊 DETAILED BREAKDOWN
    const productBreakdown = formData.products.map((product, index) => ({
      index,
      productName: product.productName?.substring(0, 20) + '...',
      netAmount: roundTo2(product.netAmount || 0),
      quantity: product.quantity
    }));

    // 1️⃣ Sum of ALL product netAmounts
    const subtotalProducts = formData.products.reduce((sum, product) => {
      return sum + roundTo2(product.netAmount || 0);
    }, 0);

    // 2️⃣ Delivery Charges
    const deliveryChargesAmount = parseFloat(formData.deliveryCharges || 0);

    // 3️⃣ FINAL TOTAL
    const totalNetAmount = Math.floor((subtotalProducts + deliveryChargesAmount) * 100) / 100;

    // Update formData
    setFormData(prev => ({
      ...prev,
      totalAmount: totalNetAmount
    }));

    // 🔥 DETAILED CONSOLE LOG
    console.log("🔥 TOTAL BREAKDOWN:", {
      timestamp: new Date().toLocaleTimeString(),
      productsCount: formData.products.length,

      // 📈 BREAKDOWN
      subtotalProducts: Math.floor(subtotalProducts * 100) / 100,
      deliveryCharges: Math.floor(deliveryChargesAmount * 100) / 100,
      totalNetAmount,

      // 📋 Individual Products
      productBreakdown: productBreakdown,

      // 🔍 Raw Values Check
      rawDeliveryCharges: formData.deliveryCharges,
      sampleMode
    });

    // 🧮 Quick Summary Table (console)
    console.table(productBreakdown);
    console.log(`📊 SUMMARY: Products=${Math.floor(subtotalProducts * 100) / 100} + Delivery=${Math.floor(deliveryChargesAmount * 100) / 100} = TOTAL=${totalNetAmount}`);

  }, [formData.products, formData.deliveryCharges, sampleMode]);

  // Refactored isCreditPaymentAllowed to include COD limit logic
  const isCreditPaymentAllowed = async (
    customerId,
    entity,
    totalAmount = formData.totalAmount
  ) => {
    try {
      const creditUrl = `${API_BASE_URL}/payment-method-balances/id/${customerId}`;
      const creditRes = await fetch(creditUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!creditRes.ok) {
        console.warn("Failed to fetch credit eligibility:", creditRes.statusText);
        return { allowed: false };
      }

      const creditResult = await creditRes.json();
      const isCreditUser =
        creditResult?.data?.methodDetails?.credit?.[entity]?.isAllowed;

      if (!isCreditUser) {
        const isCODAllowed = creditResult?.data?.methodDetails?.COD?.isAllowed;
        const isPrePaymentAllowed =
          creditResult?.data?.methodDetails?.prePayment?.isAllowed;

        console.log("Payment method checks:", {
          isCODAllowed,
          isPrePaymentAllowed,
        });

        if (isCODAllowed && !isPrePaymentAllowed) {
          const codLimit = creditResult?.data?.methodDetails?.COD?.limit || 0;

          if (Number(totalAmount) > Number(codLimit)) {
            Swal.fire({
              icon: "warning",
              title: t("COD Limit Exceeded"),
              text: t(`The total amount exceeds the COD limit of ${codLimit}.`),
            });
            setSaving(false);
            return { allowed: false };
          }

          return { allowed: true, paymentMethod: "Cash on Delivery" };
        }

        if (isPrePaymentAllowed && !isCODAllowed) {
          return { allowed: true, paymentMethod: "Pre Payment" };
        }

        if (isCODAllowed && isPrePaymentAllowed) {
          setShowPaymentPopup(true);
          setPendingSaveAction(true);
          return { allowed: "Payment popup" };
        }

        Swal.fire({
          icon: "warning",
          title: t("No Payment Methods Available"),
          text: t("No valid payment methods are available for this customer."),
        });
        setSaving(false);
        return { allowed: false };
      }

      console.log("Credit is allowed for customer. checking for current balance");

      const currentCreditBalance =
        Number(creditResult?.data?.currentBalance?.[entity] || 0);

      const netAmountTotal =
        formData?.products?.reduce(
          (total, item) => total + Number(item.netAmount || 0),
          0
        ) || 0;

      const unblockUntilRaw = formData?.customerUnblockedUntil;
      const unblockUntil = unblockUntilRaw ? new Date(unblockUntilRaw) : null;
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const unblockDateOnly = unblockUntil ? new Date(unblockUntil) : null;
      if (unblockDateOnly && !isNaN(unblockDateOnly.getTime())) {
        unblockDateOnly.setHours(0, 0, 0, 0);
      }

      // Credit sufficient => no need to check unblock date, continue directly
      if (netAmountTotal <= currentCreditBalance) {
        try {
          const creditPeriodResponse = await fetch(
            `${API_BASE_URL}/get-upadted-credit-block-customer?erpCustId=${formData.erpCustId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (!creditPeriodResponse.ok) {
            console.warn(
              "Failed to fetch credit period data:",
              creditPeriodResponse.statusText
            );
            return { allowed: true, paymentMethod: "Credit" };
          }

          const creditPeriodResult = await creditPeriodResponse.json();

          if (!creditPeriodResult.success) {
            console.warn(
              "Credit period check failed:",
              creditPeriodResult.message
            );

            if (creditPeriodResult.details === null) {
              Swal.fire({
                icon: "warning",
                title: t("Credit Check Failed"),
                text: t(
                  creditPeriodResult.message ||
                  "Unable to verify credit eligibility"
                ),
              });
              setSaving(false);
              return { allowed: false };
            }

            return { allowed: true, paymentMethod: "Credit" };
          }

          const entityCreditData = creditPeriodResult?.details?.[entity];

          if (entityCreditData?.Block) {
            const reason = entityCreditData?.Reason || "Credit is not available";
            Swal.fire({
              icon: "warning",
              title: t(reason),
            });
            setSaving(false);
            return { allowed: false };
          }

          return { allowed: true, paymentMethod: "Credit" };
        } catch (err) {
          console.error("Error checking credit period:", err);
          return { allowed: true, paymentMethod: "Credit" };
        }
      }

      // Credit insufficient => only now check unblock date
      if (unblockDateOnly && !isNaN(unblockDateOnly.getTime())) {
        if (today < unblockDateOnly) {
          try {
            const creditPeriodResponse = await fetch(
              `${API_BASE_URL}/get-upadted-credit-block-customer?erpCustId=${formData.erpCustId}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            if (!creditPeriodResponse.ok) {
              console.warn(
                "Failed to fetch credit period data:",
                creditPeriodResponse.statusText
              );
              return { allowed: true, paymentMethod: "Credit" };
            }

            const creditPeriodResult = await creditPeriodResponse.json();

            if (!creditPeriodResult.success) {
              console.warn(
                "Credit period check failed:",
                creditPeriodResult.message
              );

              if (creditPeriodResult.details === null) {
                Swal.fire({
                  icon: "warning",
                  title: t("Credit Check Failed"),
                  text: t(
                    creditPeriodResult.message ||
                    "Unable to verify credit eligibility"
                  ),
                });
                setSaving(false);
                return { allowed: false };
              }

              return { allowed: true, paymentMethod: "Credit" };
            }

            const entityCreditData = creditPeriodResult?.details?.[entity];

            if (entityCreditData?.Block) {
              const reason = entityCreditData?.Reason || "Credit is not available";
              Swal.fire({
                icon: "warning",
                title: t(reason),
              });
              setSaving(false);
              return { allowed: false };
            }

            return { allowed: true, paymentMethod: "Credit" };
          } catch (err) {
            console.error("Error checking credit period:", err);
            return { allowed: true, paymentMethod: "Credit" };
          }
        }

        const formattedDate = unblockDateOnly.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });

        Swal.fire({
          icon: "warning",
          title: t("Customer Blocked"),
          text: t(`Customer is blocked from ${formattedDate}.`),
        });
        setSaving(false);
        return { allowed: "Blocked customer" };
      }

      // Credit insufficient and no unblock date
      Swal.fire({
        icon: "warning",
        title: t("Insufficient Credit balance"),
        text: t(`Your credit balance is ${currentCreditBalance}.`),
      });
      setSaving(false);
      return { allowed: "Insufficient balance" };
    } catch (err) {
      console.error("Error in isCreditPaymentAllowed:", err);
      return { allowed: false };
    }
  };

  // Add a default product row in add mode
  useEffect(() => {
    if (formMode === "add" && formData.products.length === 0) {
      // Do not add an empty row by default
      setFormData((prev) => ({
        ...prev,
        products: [],
      }));
    }
    // eslint-disable-next-line
  }, [formMode]);

  // quantity change handler
  // Quantity change handler
  const handleQuantityChange = (idx, value) => {
    setFormData((prev) => {
      const updatedProducts = [...prev.products];

      // Handle both numeric and string values (for partial input states)
      if (typeof value === "string" && value !== "") {
        // For string inputs, store as-is to allow user typing
        updatedProducts[idx].quantity = value;
      } else if (typeof value === "number") {
        // For numeric inputs, ensure it's a valid number
        updatedProducts[idx].quantity = Math.max(0, parseInt(value, 10) || 0);
      } else if (value === "" || value === undefined) {
        // For empty values, store as empty string
        updatedProducts[idx].quantity = "";
      } else {
        // Fallback to 0 for any other case
        updatedProducts[idx].quantity = 0;
      }

      // Only calculate net amount for valid numeric quantities
      const numericQuantity =
        typeof value === "number" ? value : parseInt(value, 10);
      if (!isNaN(numericQuantity) && numericQuantity >= 0) {
        // Update the net amount based on the new quantity
        if (sampleMode) {
          updatedProducts[idx].netAmount = "0.00";
        } else {
          const unitPrice = Math.floor(updatedProducts[idx].unitPrice * 100) / 100; // Ensure unit price is treated as a number with 2 decimals
          const vatPercentage = Math.floor(updatedProducts[idx].vatPercentage * 100) / 100; // Ensure VAT percentage is treated as a number with 2 decimals
          const baseAmount = unitPrice * numericQuantity;
          const vatAmount = baseAmount * (vatPercentage / 100);
          updatedProducts[idx].netAmount = roundTo2((baseAmount + vatAmount));
        }
      }

      return {
        ...prev,
        products: updatedProducts,
      };
    });
  };

  // Delete product row handler
  const handleDeleteProductRow = (idx) => {
    setFormData((prev) => ({
      ...prev,
      products: prev.products.filter((_, i) => i !== idx),
    }));
  };

  // Download invoice
  const handleDownloadInvoice = (orderId) => {
    Swal.fire({
      title: t("Download Invoice"),
      text: `Are you sure you want to download the invoice for order ID:${orderId}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("OK"),
    });
  };

  const handleSave = async (action, selectedMethod) => {
    if (isProcessingRef.current) return;
    isProcessingRef.current = true;
    const itemsWithInvalidMOQ = [];
    const updatedProducts = [...formData.products];
    // TODO: To check if this is required................................................
    for (let i = 0; i < formData.products.length; i++) {
      const product = formData.products[i];
      const currentQuantity = Number(product.quantity) || 0;
      let moq = 1;
      try {
        const response = await fetch(`${API_BASE_URL}/product-customer-mappings/pagination?filters={"productId":"${product.id}","customerId":"${formData.customerId}"}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        moq = data?.data?.[0]?.moq || 1;

      } catch (error) {
        console.error("Error fetching product-customer mapping:", error);
      }
      // Check if quantity is below MOQ
      if (!sampleMode && currentQuantity < moq) {
        itemsWithInvalidMOQ.push({
          name: product.productName,
          currentQuantity,
          moq,
          index: i,
        });

        Swal.fire({
          title: t('Minimum Order Quantity'),
          text: t('The quantity is below the minimum order quantity'),
          icon: 'warning',
          showConfirmButton: false,
          timer: 1000,
          backdrop: true,
          allowOutsideClick: true
        });

        // Update the quantity to MOQ
        updatedProducts[i] = {
          ...product,
          quantity: moq,
        };
      }
    }

    // If there are items with invalid MOQ, show warning and update quantities
    if (itemsWithInvalidMOQ.length > 0) {
      // Update the formData with MOQ values
      setFormData((prev) => ({
        ...prev,
        products: updatedProducts,
      }));

      // Recalculate net amounts after MOQ correction
      const finalUpdatedProducts = updatedProducts.map((product) => {
        const unitPrice = Math.floor(product.unitPrice * 100) / 100;
        const quantity = parseInt(product.quantity);
        const vatPercentage = Math.floor(product.vatPercentage * 100) / 100;
        const baseAmount = unitPrice * quantity;
        const vatAmount = baseAmount * (vatPercentage / 100);

        return {
          ...product,
          netAmount: roundTo2((baseAmount + vatAmount) * 100).toFixed(2) / 100,
        };
      });

      // Final update with recalculated amounts
      setFormData((prev) => ({
        ...prev,
        products: finalUpdatedProducts,
      }));

      return;
    }
    setSaving(true);
    //.....................................................................................
    // Basic validations first
    //TODO: Swal fire the alert
    if (!formData.customerId) {
      alert(t("Please select a customer"));
      setSaving(false);
      return;
    }

    if (!formData.products || formData.products.length === 0) {
      Swal.fire({
        icon: "warning",
        title: t("Validation Error"),
        text: t("Please add at least one product"),
        confirmButtonText: t("OK"),
      });
      setSaving(false);
      isProcessingRef.current = false;
      return;
    }

    // Check if editing Pre Payment order
    if (formMode !== "add" && formData.paymentMethod === "Pre Payment") {
      Swal.fire({
        icon: "warning",
        title: t("No Updates Allowed"),
        text: t(
          "The payment method is Pre Payment. The order cannot be altered."
        ),
      });
      setSaving(false);
      isProcessingRef.current = false;
      return;
    }

    // Determine payment method first if not provided and not in edit mode
    let finalPaymentMethod = selectedMethod;

    // **SAMPLE MODE CHECK - Override payment method determination**
    if (sampleMode) {
      selectedMethod = "Pre Payment"
      finalPaymentMethod = selectedMethod;
    } else if (formMode === "add" && !selectedMethod) {
      // Original payment method determination logic
      const isVmcoEntity = formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase();

      if (isVmcoEntity) {
        const machineProducts = formData.products.length > 0 &&
          formData.products.every(product => product.isMachine === true);

        if (machineProducts) {
          finalPaymentMethod = "Pre Payment";
        } else {
          const totalAmount = parseFloat(formData.totalAmount);
          const creditCheck = await isCreditPaymentAllowed(
            formData.customerId,
            formData.entity,
            totalAmount,
            action
          );

          if (creditCheck.allowed === "Payment popup") {
            setSaving(false);
            isProcessingRef.current = false;
            return;
          } else if (creditCheck.allowed === false) {
            setSaving(false);
            isProcessingRef.current = false;
            return;
          } else if (creditCheck.allowed === "Blocked customer") {
            setSaving(false);
            isProcessingRef.current = false;
            return;
          } else if (creditCheck.paymentMethod) {
            finalPaymentMethod = creditCheck.paymentMethod;
          }
        }
      } else {
        const totalAmount = parseFloat(formData.totalAmount);
        const creditCheck = await isCreditPaymentAllowed(
          formData.customerId,
          formData.entity,
          totalAmount,
          action
        );
        if (creditCheck.allowed === "Payment popup") {
          setSaving(false);
          isProcessingRef.current = false;
          return;
        } else if (creditCheck.allowed === false) {
          setSaving(false);
          isProcessingRef.current = false;
          return;
        } else if (creditCheck.allowed === "Blocked customer") {
          setSaving(false);
          isProcessingRef.current = false;
          return;
        } else if (creditCheck.paymentMethod) {
          finalPaymentMethod = creditCheck.paymentMethod;
        }
      }
    }

    // Use existing payment method in edit mode if not changing it
    if (formMode !== "add" && !selectedMethod) {
      selectedMethod = formData.paymentMethod;
    }

    // Check COD limits if payment method is Cash on Delivery
    if (selectedMethod && selectedMethod.toLowerCase() === "cash on delivery") {
      try {
        const creditPeriodResponse = await fetch(
          `${API_BASE_URL}/get-upadted-credit-block-customer?erpCustId=${formData.erpCustId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (!creditPeriodResponse.ok) {
          console.warn(
            "Failed to fetch credit period data:",
            creditPeriodResponse.statusText,
          );
          Swal.fire({
            icon: "error",
            title: t("Credit Period Check Failed"),
            text: t("Unable to verify credit availability."),
          });
          return;
        }

        const creditPeriodResult = await creditPeriodResponse.json();

        if (!creditPeriodResult.success) {
          console.warn(
            "Credit period check failed:",
            creditPeriodResult.message,
          );
          Swal.fire({
            icon: "warning",
            title: t("Credit Check Failed"),
            text: t(
              creditPeriodResult.message ||
              "Unable to verify credit eligibility",
            ),
          });
          setSaving(false);
          return;
        }

        const entityCreditData = creditPeriodResult?.details?.[formData.entity];

        if (entityCreditData?.Block) {
          const reason = entityCreditData?.Reason || "Credit is not available";
          const remark = entityCreditData?.Remarks || "";
          Swal.fire({
            icon: "warning",
            title: t(reason),
            text: t(remark),
          });
          setSaving(false);
          return;
        }
      } catch (err) {
        console.error("Error checking credit period:", err);
        Swal.fire({
          icon: "error",
          title: t("Error"),
          text: t("An error occurred while checking credit availability."),
        });
        setSaving(false);
        return;
      }
      try {
        // Calculate current order total amount
        let currentOrderTotal = formData.totalAmount || 0;

        // Check for existing open COD orders
        const orderFilters = new URLSearchParams({
          filters: JSON.stringify({
            customerId: formData.customerId,
            entity: formData.entity,
            status: "Open",
            paymentMethod: "Cash on Delivery",
          }),
        });
        console.log(`Fetching existing orders with filters: ${formData}`);
        let COD = 'Cash on Delivery'
        const isFresh = formData?.products[0]?.isFresh

        const netAmountToatl = formData?.products?.reduce((total, item) => {
          return total + roundTo2(item.netAmount);
        }, 0);
        const existingOrdersResponse = await fetch(
          `${API_BASE_URL}/sales-order/existing-open-order?customerId=${formData?.customerId}&branchId=${formData?.branchId}&entity=${formData?.entity}&status=open&paymentMethod=${COD}&isFresh=${isFresh}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!existingOrdersResponse.ok) {
          throw new Error("Failed to fetch existing COD orders");
        }

        const existingOrdersResult = await existingOrdersResponse.json();

        // Calculate total amount of existing COD orders
        let existingCODTotal = 0;
        if (existingOrdersResult?.success && existingOrdersResult?.details) {

          // Skip current order if we're editing
          if (existingOrdersResult?.details?.id !== formData.id) {
            existingCODTotal += Number(existingOrdersResult?.details?.totalAmount) || 0;
          }

        }

        // Get customer's COD limit
        const customerResponse = await fetch(
          `${API_BASE_URL}/payment-method-balances/id/${formData.customerId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!customerResponse.ok) {
          throw new Error("Failed to fetch customer COD limit");
        }

        const customerData = await customerResponse.json();
        console.log("Customer COD limit data:", customerData);
        const codLimit =
          Number(customerData?.data?.methodDetails?.COD?.limit) || 0;

        // Compare total with COD limit
        if (netAmountToatl >= codLimit) {
          console.log(
            `COD limit reached: existing=${existingCODTotal}, Sum=${existingCODTotal + Number(currentOrderTotal)
            }, current=${currentOrderTotal}, limit=${codLimit}`
          );
          Swal.fire({
            icon: "warning",
            title: t("COD Limit Reached"),
            text: t(
              "The COD Limit of the customer has been reached. Please choose a different payment method."
            ),
            confirmButtonText: t("OK"),
          });
          setSaving(false);
          isProcessingRef.current = false;
          return;
        }
        console.log("COD limit check passed. Continuing with order placement.");
      } catch (error) {
        console.error("Error checking COD limits:", error);
        Swal.fire({
          icon: "error",
          title: t("Error"),
          text: t("Failed to verify COD limits. Please try again."),
          confirmButtonText: t("OK"),
        });
        setSaving(false);
        isProcessingRef.current = false;
        return;
      }
    }

    if (selectedMethod && selectedMethod.toLowerCase() === "credit") {
      const netAmountToatl = formData?.products?.reduce((total, item) => {
        return total + roundTo2(item.netAmount);
      }, 0);
      const isCredit = await isCreditPaymentAllowed(
        formData.customerId,
        formData.entity,
        netAmountToatl
      );
      if (isCredit == "Insufficient balance") {
        setSaving(false)
        isProcessingRef.current = false;
        return;
      } else if (isCredit == "Blocked customer") {
        setSaving(false)
        isProcessingRef.current = false;
        return;
      }

    }

    if (formMode !== "add" && formData.paymentMethod === "Pre Payment") {
      // alert(t('The payment method is Pre Payment. The order cannot be altered.'));
      Swal.fire({
        icon: "warning",
        title: t("No Updations Allowed"),
        text: t(
          "The payment method is Pre Payment. The order cannot be altered."
        ),
      });
      setSaving(false);
      isProcessingRef.current = false;
      return;
    }
    //TODO: Remove repeated codes..........................(Add a seperate function to vaidate basic things)
    if (!formData.customerId) {
      alert(t("Please select a customer"));
      setSaving(false);
      isProcessingRef.current = false;
      return;
    }
    setSaving(true);

    if (!formData.products || formData.products.length === 0) {
      Swal.fire({
        icon: "warning",
        title: t("Validation Error"),
        text: t("Please add at least one product"),
      });
      setSaving(false);
      isProcessingRef.current = false;
      return;
    }

    // Enhanced payment method determination logic
    if (formMode === "add" && !formData.paymentMethod && !selectedMethod) {
      // Check entity type and product composition
      const isVmcoEntity =
        formData.entity &&
        formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase();

      if (isVmcoEntity) {
        // For VMCO entity, check if all products are machines
        const machineProducts =
          formData.products.length > 0 &&
          formData.products.every((product) => product.isMachine === true);

        if (machineProducts) {
          // All products are machines - use Pre Payment
          console.log("All products are VMCO machines - using Pre Payment");
          selectedMethod = "Pre Payment";
        } else {
          // Non-machine products: check credit user and COD limit
          console.log(
            "VMCO entity with non-machine products - determining payment method"
          );
          const totalAmount = parseFloat(formData.totalAmount);
          const creditCheck = await isCreditPaymentAllowed(
            formData.customerId,
            formData.entity,
            totalAmount,
            action
          );

          if (creditCheck.allowed === "Payment popup") {
            setSaving(false);

            return;
          }
          if (creditCheck.allowed === "Insufficient balance") {
            console.log("Credit not allowed - insufficient balance");
            setSaving(false);
            isProcessingRef.current = false;
            return;
          } else if (creditCheck.allowed === "Blocked customer") {
            console.log("Credit not allowed - blocked customer");
            setSaving(false);
            isProcessingRef.current = false;
            return;
          } else if (creditCheck.paymentMethod) {
            selectedMethod = creditCheck.paymentMethod;
          }
        }
      } else {
        console.log("Other entity - determining payment method");
        const totalAmount = parseFloat(formData.totalAmount);
        const creditCheck = await isCreditPaymentAllowed(
          formData.customerId,
          formData.entity,
          totalAmount,
          action
        );

        if (creditCheck.allowed === "Payment popup") {
          setSaving(false);
          isProcessingRef.current = false;
          return;
        } else if (creditCheck.allowed === "Insufficient balance") {
          console.log("Credit not allowed - insufficient balance");
          setSaving(false);
          isProcessingRef.current = false;
          return;
        } else if (creditCheck.allowed === "Blocked customer") {
          console.log("Credit not allowed - blocked customer");
          setSaving(false);
          isProcessingRef.current = false;
          return;
        } else if (creditCheck.paymentMethod) {
          selectedMethod = creditCheck.paymentMethod;
        }
      }
    }

    // Always check and determine payment method before proceeding
    if (!selectedMethod) {
      if (
        formData.category &&
        formData.category.toLowerCase() ===
        Constants.CATEGORY.VMCO_MACHINES.toLowerCase()
      ) {
        selectedMethod = "Pre Payment";
      } else if (formData.paymentMethod) {
        selectedMethod = formData.paymentMethod;
      } else {
        // Check entity type and product composition
        const isVmcoEntity =
          formData.entity &&
          formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase();
        if (isVmcoEntity) {
          // For VMCO entity, check if all products are machines
          const machineProducts =
            formData.products.length > 0 &&
            formData.products.every((product) => product.isMachine === true);
          if (machineProducts) {
            selectedMethod = "Pre Payment";
          }
        }
      }
    }

    // If still no payment method determined, show error
    if (!selectedMethod) {
      Swal.fire({
        icon: "warning",
        title: t("Payment Method Required"),
        text: t("Please select a payment method before saving the order."),
        confirmButtonText: t("OK"),
      });
      setSaving(false);
      isProcessingRef.current = false;
      return;
    }

    // Check if we're editing an existing order or creating a new one
    if (formData.id && isEditMode) {
      const fieldsToUpdate = [
        "erpCustId",
        "erpBranchId",
        "orderBy",
        "entity",
        "sampleOrder",
        "paymentMethod",
        "paymentPercentage",
        "totalAmount",
        "paidAmount",
        "deliveryCharges",
        "expectedDeliveryDate",
        "status",
        "driver",
        "vehicleNumber",
        "branchRegion",
        "branchCity",
        "erpWarehouseId",
        "warehouseNameEn",
        "warehouseNameAr"
      ];

      const payload = {}; // Check if category is VMCO Machines
      const isVmcoMachinesCategory = formData.category && formData.category.toLowerCase() === Constants.CATEGORY.VMCO_MACHINES.toLowerCase();
      const isShcFreshCategory = formData.category && formData.category.toLowerCase() === Constants.CATEGORY.SHC_FRESH.toLowerCase();
      fieldsToUpdate.forEach(field => {
        if (formData[field] !== undefined && formData[field] !== null) {
          if (field === "paymentPercentage") {
            payload[field] = formData[field]
              ? formData[field] === 100
                ? 100.0
                : formData[field] === 30
                  ? 30.0
                  : 0.0
              : 0.0;
          } else if (field === "paymentMethod") {
            // **SAMPLE MODE: Use Pre Payment**
            payload[field] = sampleMode ? "Pre Payment" : finalPaymentMethod;
          } else if (field === "status") {
            if (sampleMode) {
              if (formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase()) {
                payload[field] = "Pending";
              } else if (formData.entity && (formData.entity.toLowerCase() === Constants.ENTITY.SHC.toLowerCase() || formData.entity.toLowerCase() === Constants.ENTITY.GMTC.toLowerCase())) {
                payload[field] = "Open";
              } else if (formData.entity && (formData.entity.toLowerCase() === Constants.ENTITY.NAQI.toLowerCase() || formData.entity.toLowerCase() === Constants.ENTITY.DAR.toLowerCase())) {
                payload[field] = "Approved";
              } else {
                payload[field] = "Pending"; // Fallback
              }
            } else if (formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase()) {
              // Set status to Pending for vmco entity (non-sample mode)
              payload[field] = "Pending";
            } else {
              // For non-sample mode and non-VMCO entities, keep the current status
              payload[field] = formData[field];
            }
          } else if (field === "paidAmount") {
            // **SAMPLE MODE: Set paidAmount to totalAmount when Paid**
            payload[field] = sampleMode ? formData.totalAmount || 0.0 : formData[field];
          } else if (field === "expectedDeliveryDate") {
            // Handle date fields - convert empty strings to null to avoid database errors
            payload[field] = safeDateValue(formData[field]);
          } else {
            payload[field] = formData[field];
          }
        }
      });

      payload.paymentStatus = sampleMode ? "Paid" : formData.paymentStatus || "Pending";

      const netAmountToatl = formData?.products?.reduce((total, item) => {
        return total + roundTo2(item.netAmount);
      }, 0);


      // First update the sales order
      const orderResponse = await fetch(
        `${API_BASE_URL}/sales-order/id/${formData.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );
      if (!orderResponse.ok) {
        const errorData = await orderResponse
          .json()
          .catch(() => ({ message: "Unknown error" }));
        console.error("Server response:", errorData);
        Swal.fire({
          icon: "error",
          title: t("Error"),
          text:
            errorData.details ||
            errorData.message ||
            `Failed to update order: ${orderResponse.statusText}`,
        });

        setSaving(false);
        isProcessingRef.current = false;
        return;
      }

      // Now check for existing order lines and fetch them
      let existingProductMap = {};
      try {
        const linesResponse = await fetch(
          `${API_BASE_URL}/sales-order-lines/pagination?page=1&pageSize=10000&filters=${encodeURIComponent(
            JSON.stringify({ orderId: formData.id })
          )}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!linesResponse.ok) {
          console.warn(
            `Failed to fetch order lines: ${linesResponse.statusText}`
          );
        } else {
          const existingLines = await linesResponse.json();
          if (existingLines.data?.data?.length > 0) {
            // Filter to ensure we only get lines for this specific order
            const orderLines = existingLines.data.data.filter(
              (line) => line.orderId === formData.id
            );
            console.log(
              `Existing order lines for orderId ${formData.id}:`,
              orderLines
            );

            orderLines.forEach((line) => {
              if (line.productId) {
                existingProductMap[line.productId] = line.productId;
                console.log(
                  `Mapped existing line for product ID ${line.productId} to line ID ${line.id}`
                );
              } else {
                console.warn(`Found order line without product_id:`, line);
              }
            });
          }
        }
      } catch (err) {
        console.error("Error fetching existing order lines:", err);
      }
      // Track if any products were deleted for success message
      let productsDeleted = false;
      // Now update each product line
      // Check for deleted products by comparing originalProducts with current products
      if (originalProducts && originalProducts.length > 0) {
        console.log("Checking for deleted products...");

        // Create a map of current products for easy lookup
        const currentProductsMap = {};
        formData.products.forEach((product) => {
          const productId = product.id || product.productId;
          if (productId) {
            currentProductsMap[productId] = true;
          }
        });

        // Find products that were in originalProducts but are no longer in formData.products
        const deletePromises = originalProducts
          .filter((product) => {
            const productId = product.id || product.productId;
            return productId && !currentProductsMap[productId];
          })
          .map((product) => {
            const productId = product.id || product.productId;
            console.log(`Deleting removed product ID ${productId} from order`);
            return deleteSalesOrderLine(formData.id, productId);
          });

        // Wait for all delete operations to complete
        if (deletePromises.length > 0) {
          console.log(`Found ${deletePromises.length} products to delete`);
          await Promise.all(deletePromises);
          productsDeleted = true;
        } else {
          console.log("No products were removed from the order");
        }
      }
      if (formData.products && formData.products.length > 0) {
        console.log("Updating sales order lines");

        const updatePromises = formData.products.map((product) => {
          // Extract product data
          const productId = product.id || product.productId;
          const unitPrice = Math.floor(product.unitPrice * 100) / 100;
          const quantity = parseInt(product.quantity, 10);
          const netAmount = roundTo2(product.netAmount);
          const vatPercentage = Math.floor(product.vatPercentage * 100) / 100;
          const lineDiscount = Math.floor(product.lineDiscount * 100) / 100;

          // Check if product already exists in the order
          const existingLine = existingProductMap[productId];

          if (existingLine) {
            console.log(
              `Found existing line for product ID ${productId}, updating quantity, amounts, and discount`
            );
            // Update existing line with lineDiscount
            return updateSalesOrderLine(
              formData.id,
              productId,
              unitPrice,
              quantity,
              netAmount,
              vatPercentage,
              lineDiscount
            );
          }
          // Existing products with salesOrderLineId but not found in existingProductMap
          else if (product?.salesOrderLineId && product?.salesOrderLineId) {
            console.log(
              `Product has salesOrderLineId ${product.salesOrderLineId} but not found in existing lines, updating`
            );
            return updateSalesOrderLine(
              formData.id,
              productId,
              unitPrice,
              quantity,
              netAmount,
              vatPercentage,
              Math.floor(product.lineDiscount * 100) / 100
            );
          }
          // New products need to be added
          else if (!existingLine) {
            console.log(`Creating new line for product ID ${productId}`);

            return createSalesOrderLine(
              formData.id,
              productId,
              product.erpProdId,
              unitPrice,
              quantity,
              netAmount,
              vatPercentage,
              lineDiscount
            );
          }
        });
        await Promise.all(updatePromises);

        // After updating sales order lines, calculate and update totalSalesTaxAmount
        let totalSalesTaxAmount = 0;
        formData.products.forEach((product) => {
          const unitPrice = Math.floor(product.unitPrice * 100) / 100;
          const quantity = parseInt(product.quantity || 0, 10);
          const vatPercentage = Math.floor(product.vatPercentage * 100) / 100;
          const baseAmount = Math.floor((unitPrice) * quantity * 100) / 100;
          const vatAmount = ((baseAmount * vatPercentage * 100) / 100) / 100;
          totalSalesTaxAmount += vatAmount;
        });

        console.log(
          "Total sales tax amount for updated order:",
          totalSalesTaxAmount
        );

        // Check if any product is a machine (isMachine = true)
        const hasAnyMachine =
          formData.products.length > 0 &&
          formData.products.some((product) => product.isMachine === true);

        // Check if any product is fresh (isFresh = true)
        const hasAnyFresh =
          formData.products.length > 0 &&
          formData.products.some((product) => product.isFresh === true);

        console.log("Product analysis:", {
          totalProducts: formData.products.length,
          hasAnyMachine,
          hasAnyFresh,
          sampleOrder: sampleMode ? true : false,
          productFlags: formData.products.map((p) => ({
            id: p.id,
            isMachine: p.isMachine,
            isFresh: p.isFresh,
          })),
        });

        // Update the sales order with the total sales tax amount and product flags
        const orderUpdatePayload = {
          total_sales_tax_amount: Math.floor(totalSalesTaxAmount * 100) / 100,
          isMachine: hasAnyMachine,
          isFresh: hasAnyFresh,
        };

        const updateOrderResponse = await fetch(
          `${API_BASE_URL}/sales-order/id/${formData.id}`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(orderUpdatePayload),
          }
        );

        if (!updateOrderResponse.ok) {
          console.warn(
            "Failed to update order with total sales tax amount and product flags"
          );
        } else {
          console.log(
            "Successfully updated order with total sales tax amount and product flags:",
            {
              totalSalesTaxAmount,
              isMachine: hasAnyMachine,
              isFresh: hasAnyFresh,
            }
          );
        }
      }




      // // Check if this is a VMCO Machines order that needs discount workflow approval
      // if ((formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase()) &&
      //   (formData.isMachine && formData.isMachine === true) &&
      //   formData.customerId) {
      //   // Directly trigger the discount workflow without checking if it already exists
      //   console.log(`Directly triggering discount workflow for order ${formData.id}`);
      //   console.log(`- formData.entity: "${formData.entity}"`);
      //   console.log(`- formData.isMachine: "${formData.isMachine}"`);
      //   console.log(`- formData.customerId: ${formData.customerId}`);

      //   await triggerDiscountWorkflow(formData.id, formData.customerId);
      // } else {
      //   console.log('Skipping discount workflow creation in order update because conditions failed:');
      //   console.log(`- entity is vmco (case insensitive): ${formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase()}`);
      //   console.log(`- isMachine is true: ${formData.isMachine && formData.isMachine === true}`);
      //   console.log(`- has customerID: ${Boolean(formData.customerId)}`);
      // }

      setIsEditMode(false);

      // Show specific success message based on whether products were deleted
      if (productsDeleted) {
        Swal.fire({
          icon: "success",
          title: t("Order Updated Successfully"),
          text: t(
            "The order has been successfully updated with product changes!"
          ),
          confirmButtonText: t("OK"),
        }).then(() => {
          navigate("/orders");
        });
      } else {
        Swal.fire({
          icon: "success",
          title: t("Order Updated"),
          text: t("Order updated successfully!"),
          confirmButtonText: t("OK"),
        }).then(() => {
          navigate("/orders");
        });
      }
      return; // Exit function after successful update
    }

    // Validation - check if essential fields are filled
    if (!formData.selectedCustomerName || !formData.selectedBranchName) {
      Swal.fire({
        icon: "warning",
        title: t("Validation Error"),
        text: t("Customer and Branch are required fields."),
      });
      setSaving(false);
      isProcessingRef.current = false;
      return;
    }
    if (!formData.entity) {
      Swal.fire({
        icon: "warning",
        title: t("Validation Error"),
        text: t("Entity is a required field."),
        confirmButtonText: t("OK"),
      });
      setSaving(false);
      isProcessingRef.current = false;
      return;
    }
    console.log("Starting order creation process with data:", {
      customerId: formData.customerId,
      branchId: formData.branchId,
      entity: formData.entity,
      category: formData.category,
      paymentMethod: selectedMethod,
    });

    // Skip existing order check if payment method is Pre Payment
    const isPrePayment =
      (selectedMethod || formData.paymentMethod).toLowerCase() ===
      "pre payment";
    if (!isPrePayment) {
      console.log(
        "Payment method is Pre Payment - skipping existing order check"
      );
      const branchIdForFilter = formData.branchId || formData.erpBranchId;

      // Determine the status to check for existing orders based on entity
      const statusToCheck =
        formData.entity &&
          formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase()
          ? "Pending" // VMCO orders use Pending status
          : "Open"; // Other entities use Open status

      const freshOrder =
        Array.isArray(formData.products) &&
        formData.products.length > 0 &&
        formData.products.every((product) => product.isFresh === true);

      const orderFiltersObj =
        formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase()
          ? {
            customerId: formData.customerId,
            branchId: branchIdForFilter,
            entity: formData.entity,
            status: statusToCheck,
            productCategory: formData.category,
          }
          : formData.entity &&
            formData.entity.toLowerCase() === Constants.ENTITY.SHC.toLowerCase()
            ? {
              customerId: formData.customerId,
              branchId: branchIdForFilter,
              entity: formData.entity,
              status: statusToCheck,
              isFresh: freshOrder, // or set this based on your logic if needed
              paymentMethod: selectedMethod?.toLowerCase() === "cash on delivery" ? "Cash on Delivery" : "Credit", // Include payment method filter for SHC entity if COD is selected
            }
            : {
              customerId: formData.customerId,
              branchId: branchIdForFilter,
              entity: formData.entity,
              status: statusToCheck,
              paymentMethod: selectedMethod?.toLowerCase() === "cash on delivery" ? "Cash on Delivery" : "Credit", // Include payment method filter for SHC entity if COD is selected

            };

      console.log("Order filter object created:", orderFiltersObj);

      // Always include status: 'Open' and sample order = false in the filters for existing order check
      const orderFiltersObjWithOpenStatus = {
        ...orderFiltersObj,
        status: "Open",
        sampleOrder: false
      };
      const orderFilters = new URLSearchParams({
        filters: JSON.stringify(orderFiltersObjWithOpenStatus),
      });

      console.log(
        "Checking for existing orders with filters:",
        orderFiltersObj
      );

      try {
        const existingOrderResponse = await fetch(
          `${API_BASE_URL}/sales-order/pagination?${orderFilters}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log(
          "Existing order response status:",
          existingOrderResponse.status
        );

        if (!existingOrderResponse.ok) {
          throw new Error(
            `Failed to check existing orders: ${existingOrderResponse.statusText}`
          );
        }

        const existingOrderResult = await existingOrderResponse.json();
        console.log("Existing order search results:", existingOrderResult);

        if (existingOrderResult.data?.data?.length > 0) {
          console.log(
            "Found existing order(s):",
            existingOrderResult.data.data
          );
          const entityName =
            formData.entity.charAt(0).toUpperCase() +
            formData.entity.slice(1).toLowerCase();
          Swal.fire({
            icon: "warning",
            title: t("Order Already Exists"),
            text: t(
              `An active order already exists for ${entityName} with the same customer, branch, and entity. Please check the existing orders before creating a new one.`
            ),
            confirmButtonText: t("OK"),
          });
          navigate("/orders");
          setSaving(false);
          isProcessingRef.current = false;
          return;
        } else {
          console.log(
            "No existing orders found with these criteria, proceeding with order creation"
          );
        }
      } catch (error) {
        console.error("Error checking for existing orders:", error);
        // Continue with order creation even if checking fails
        isProcessingRef.current = false;
      }
    }

    let attempt = 0;
    let maxAttempts = 2;
    let orderByName = "";
    const userId = user?.userId;
    let usernameApiUrl = `/user/get-username-by-id/${userId}`;
    const usernameRes = await fetch(`${API_BASE_URL}${usernameApiUrl}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${token}` },
    });
    if (usernameRes.ok) {
      const contentType = usernameRes.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        const usernameResult = await usernameRes.json();
        if (
          usernameResult &&
          (usernameResult.userName || usernameResult.username)
        ) {
          orderByName = usernameResult.userName || usernameResult.username;
        } else {
          console.warn(
            "Username API did not return userName field:",
            usernameResult
          );
        }
      }
    } else {
      console.error("Failed to fetch username: HTTP", usernameRes.status);
    }

    while (attempt < maxAttempts) {
      let orderStatus;
      let paymentStatus = "Pending";

      if (sampleMode) {
        finalPaymentMethod = "Pre Payment";
        paymentStatus = "Paid";
        if (formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase()) {
          orderStatus = "Pending";
        } else if (formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.SHC.toLowerCase() || formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.GMTC.toLowerCase()) {
          orderStatus = "Open";
        } else if (formData.entity && (formData.entity.toLowerCase() === Constants.ENTITY.NAQI.toLowerCase() || formData.entity.toLowerCase() === Constants.ENTITY.DAR.toLowerCase())) {
          orderStatus = "Approved";
        } else {
          orderStatus = "Pending";
        }
      } else {
        if (formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase()) {
          orderStatus = "Pending";
          if (finalPaymentMethod.toLowerCase() === "pre payment") {
            paymentStatus = "Pending";
          } else if (finalPaymentMethod.toLowerCase() === "credit") {
            orderStatus = "Pending";
            paymentStatus = "Credit";
          }
        } else if (formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.SHC.toLowerCase()) {
          orderStatus = "Open";
          paymentStatus = finalPaymentMethod === "Credit" ? "Credit" : "Pending";
        } else if (formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.GMTC.toLowerCase()) {
          orderStatus = "Open";
          paymentStatus = finalPaymentMethod === "Credit" ? "Credit" : "Pending";
        } else {
          // For NAQI and DAR entities
          if (finalPaymentMethod.toLowerCase() === "pre payment") {
            orderStatus = "Pending";
            paymentStatus = "Pending";
          } else if (finalPaymentMethod.toLowerCase() === "credit" || finalPaymentMethod.toLowerCase() === "cash on delivery") {
            orderStatus = "Approved";
            paymentStatus = finalPaymentMethod.toLowerCase() === "credit" ? "Credit" : "Pending";
          } else {
            orderStatus = "Approved";
            paymentStatus = "Pending";
          }
        }
      }
      if (finalPaymentMethod.toLowerCase() === "cash on delivery") {
        try {
          const creditPeriodResponse = await fetch(
            `${API_BASE_URL}/get-upadted-credit-block-customer?erpCustId=${formData.erpCustId}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (!creditPeriodResponse.ok) {
            console.warn(
              "Failed to fetch credit period data:",
              creditPeriodResponse.statusText,
            );
            Swal.fire({
              icon: "error",
              title: t("Credit Period Check Failed"),
              text: t("Unable to verify credit availability."),
            });
            setSaving(false);
            return;
          }

          const creditPeriodResult = await creditPeriodResponse.json();

          if (!creditPeriodResult.success) {
            console.warn(
              "Credit period check failed:",
              creditPeriodResult.message,
            );
            Swal.fire({
              icon: "warning",
              title: t("Credit Check Failed"),
              text: t(
                creditPeriodResult.message ||
                "Unable to verify credit eligibility",
              ),
            });
            setSaving(false);
            return;
          }

          const entityCreditData = creditPeriodResult?.details?.[formData.entity];

          if (entityCreditData?.Block) {
            const reason = entityCreditData?.Reason || "Credit is not available";
            const remark = entityCreditData?.Remarks || "";
            Swal.fire({
              icon: "warning",
              title: t(reason),
              text: t(remark),
            });
            setSaving(false);
            return;
          }
        } catch (err) {
          console.error("Error checking credit period:", err);
          Swal.fire({
            icon: "error",
            title: t("Error"),
            text: t("An error occurred while checking credit availability."),
          });
          setSaving(false);
          return;
        }
      }
      // Prepare payload for backend - only include defined fields, default to '' for missing optional fields
      const payload = {
        customerId: formData.customerId || "",
        companyNameEn: formData.companyNameEn || "",
        companyNameAr: formData.companyNameAr || "",
        brandNameEn: formData.brandNameEn || "",
        brandNameAr: formData.brandNameAr || "",
        erpCustId: formData.erpCustId,
        branchId: formData.branchId || "",
        erpBranchId: formData.erpBranchId || "",
        branchNameEn: formData.branchNameEn || "",
        branchNameLc: formData.branchNameLc || "",
        branchRegion: formData.branchRegion || "",
        branchCity: formData.branchCity || "",
        orderBy: orderByName,
        isMachine: formData.category.toLowerCase() === Constants.CATEGORY.VMCO_MACHINES.toLowerCase() ? true : false,
        paymentMethod: finalPaymentMethod,
        paymentPercentage: "100.00",
        status: orderStatus,
        salesExecutive: user.employeeId,
        paymentStatus: paymentStatus,
        entity: formData.entity || "",
        deliveryCharges: formData.deliveryCharges || "0",
        totalAmount: formData.totalAmount || "0",
        paidAmount: sampleMode ? 0.0 : finalPaymentMethod.toLowerCase() === "credit" ? formData.totalAmount : 0.0,
        pricingPolicy: formData.pricingPolicy?.[formData.entity],
        customerRegion: formData.customerRegion || "",
        productCategory: formData.category || "",
        erpWarehouseId: formData.erpWarehouseId || "",
        warehouseNameEn: formData.warehouseNameEn || "",
        warehouseNameAr: formData.warehouseNameAr || "",
        sampleOrder: sampleMode,
        orderSource: "Sales Executive"
      };
      try {
        setLoading(true);
        console.log("Submitting order payload:", payload);
        console.log("Branch-related fields in payload:", {
          branchId: payload.branchId,
          erpBranchId: payload.erpBranchId,
          branchNameEn: payload.branchNameEn,
          branchNameLc: payload.branchNameLc,
        });
        console.log("Proceeding to create a new order - no duplicates found");

        // Step 1: Create the order first
        console.log("Making API call to create sales order");
        const response = await fetch(`${API_BASE_URL}/sales-order`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        });
        console.log("Sales order API response status:", response.status);
        if (!response.ok) {
          const errorText = await response.text();
          if (
            errorText.includes("duplicate key value violates unique constraint")
          ) {
            // Duplicate erpOrderId, fetch latest max id and retry
            attempt++;
            // Fetch latest max id
            const params = new URLSearchParams({
              page: 1,
              pageSize: 1,
              sortBy: "id",
              sortOrder: "asc",
              fields: "id",
            });
            const idRes = await fetch(
              `${API_BASE_URL}/sales-order/pagination?${params.toString()}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            const idResult = await idRes.json();
            let newOrderId = 1;
            if (
              idResult.status === "Ok" &&
              idResult.data &&
              Array.isArray(idResult.data.data) &&
              idResult.data.data.length > 0
            ) {
              const ids = idResult.data.data
                .map((order) => parseInt(order.id, 10))
                .filter(Boolean);
              const maxId = ids.length > 0 ? Math.max(...ids) : 0;
              newOrderId = maxId + 1;
            }
            setNextOrderId(newOrderId.toString());
            setFormData((prev) => ({ ...prev, id: newOrderId.toString() }));
            continue; // Retry
          }
          // Handle other errors
          console.error("Server response:", errorText);
          try {
            const errorData = JSON.parse(errorText);
            throw new Error(errorData.message || "Failed to create order");
          } catch (e) {
            throw new Error(
              `Failed to create order: ${response.status} ${response.statusText}`
            );
          }
        } // Parse the response as JSON to get the inserted row's id
        const result = await response.json();
        console.log("Order creation result:", result);
        console.log(
          "Sales order created successfully with ID:",
          result.data?.id
        );

        if (!result.data || !result.data.id) {
          console.error("No order ID returned from API - cannot proceed");
          throw new Error("Order ID not returned from API");
        }
        console.log("Preparing to create order line items for products");

        // Prepare products payload, set sales_executive to empId if user is employee
        const productsPayload = formData.products.map((product, index) => {
          let vat = product.vatPercentage;
          if (companyType && companyType.toLowerCase() === "non trading") {
            vat = 0.0;
          }

          // Calculate vatAmount (salesTaxAmount)
          const baseAmount =
            Math.floor(product.unitPrice * 100) / 100 * parseInt(product.quantity || 1, 10);
          const vatAmount = (baseAmount * parseFloat(vat * 100).toFixed(2) / 100) / 100;

          return {
            orderId: result.data.id,
            lineNumber: index + 1,
            erpLineNumber: index + 1,
            productId: product.id || product.product_id,
            productName: product.productName || product.product_name_en,
            productNameLc: product.productNameLc || product.product_name_lc || "",
            erpProdId: product.erpProdId,
            isMachine: product.isMachine,
            isFresh: product.isFresh,
            quantity: parseInt(product.quantity || 1, 10),
            unit: product.unit || "",
            unitPrice: product.unitPrice,
            netAmount: product.netAmount,
            salesTaxAmount: vatAmount,
            vatPercentage: parseFloat(vat * 100).toFixed(2) / 100,
          };
        });

        console.log("Submitting products payload:", productsPayload);
        if (productsPayload.length === 0) {
          console.warn("No valid products to submit");
          Swal.fire({
            icon: "info",
            title: t("Order Created"),
            html: `<div style="text-align: center;">
                    <p style="font-size: 16px; margin-bottom: 10px;">${t(
              "Order created successfully, but no products were added."
            )}</p>
                    <p style="font-size: 18px; font-weight: bold; color: #17a2b8; margin: 10px 0;">
                        ${t("Order Number")}: #${result.data.id}
                    </p>
                    <p style="font-size: 14px; color: #666;">${t(
              "Order placed using"
            )} ${payload.paymentMethod}</p>
                  </div>`,
            confirmButtonText: t("OK"),
          });
          // alert(t('Order created successfully, but no products were added.'));
          navigate("/orders");
          return;
        }

        console.log(
          `Prepared ${productsPayload.length} product line items for submission`
        );
        try {
          console.log("Making API call to create sales order line items");
          // productsPayload[0].is_machine=true
          const linesResponse = await fetch(
            `${API_BASE_URL}/sales-order-lines`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(productsPayload),
            }
          );
          console.log(
            "Sales order lines API response status:",
            linesResponse.status
          );

          if (!linesResponse.ok) {
            // Handle HTTP error response
            const errorText = await linesResponse.text();
            console.error("Server response for product lines:", errorText);
            try {
              const errorData = JSON.parse(errorText);
              throw new Error(
                errorData.message || "Failed to save product lines"
              );
            } catch (e) {
              throw new Error(
                `Failed to save product lines: ${linesResponse.status} ${linesResponse.statusText}`
              );
            }
          }

          console.log("Sales order line items created successfully");

          // After successfully creating sales order lines, calculate and update totalSalesTaxAmount
          const totalSalesTaxAmount = productsPayload.reduce((sum, product) => {
            return sum + parseFloat(product.sales_tax_amount || 0);
          }, 0);

          console.log("Total sales tax amount:", totalSalesTaxAmount);

          // Check if any product is a machine (is_machine = true)
          const hasAnyMachine = Array.isArray(productsPayload)
            ? productsPayload.some(
              (product) =>
                product.is_machine === true || product.isMachine === true
            )
            : productsPayload.is_machine === true ||
            productsPayload.isMachine === true;

          // Check if any product is fresh (is_fresh = true)
          const hasAnyFresh = Array.isArray(productsPayload)
            ? productsPayload.some(
              (product) =>
                product.is_fresh === true || product.isFresh === true
            )
            : productsPayload.is_fresh === true ||
            productsPayload.isFresh === true;

          // Update formData with isMachine flag for future use
          setFormData((prev) => ({
            ...prev,
            isMachine: hasAnyMachine,
          }));

          console.log("Product analysis for new order:", {
            totalProducts: productsPayload.length,
            hasAnyMachine,
            hasAnyFresh,
            productFlags: productsPayload.map((p) => ({
              id: p.product_id,
              isMachine: p.isMachine,
              isFresh: p.isFresh,
            })),
          });

          // Update the sales order with the total sales tax amount and product flags
          const orderUpdatePayload = {
            total_sales_tax_amount: Math.floor(totalSalesTaxAmount * 100) / 100,
            isMachine: hasAnyMachine,
            isFresh: hasAnyFresh,
            sampleOrder: sampleMode ? true : false,
            status: orderStatus,
          };

          const updateOrderResponse = await fetch(
            `${API_BASE_URL}/sales-order/id/${result.data.id}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(orderUpdatePayload),
            }
          );

          if (!updateOrderResponse.ok) {
            console.warn(
              "Failed to update order with total sales tax amount and product flags"
            );
          } else {
            console.log(
              "Successfully updated order with total sales tax amount and product flags:",
              {
                totalSalesTaxAmount,
                isMachine: hasAnyMachine,
                isFresh: hasAnyFresh,
              }
            );
          } // If we get here, both order and products were saved successfully
          console.log("Complete order creation process finished successfully"); // Check if this is a VMCO Machines order that needs discount workflow approval
          if (
            formData.entity && formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase() &&
            formData.productCategory && formData.productCategory.toLowerCase() === Constants.CATEGORY.VMCO_MACHINES.toLowerCase() &&
            formData.customerId
          ) {
            // Directly trigger the discount workflow without checking if it already exists
            console.log(
              `Directly triggering discount workflow for order ${result.data.id}`
            );
            console.log(`- formData.entity: "${formData.entity}"`);
            console.log(
              `- formData.productCategory: "${formData.productCategory}"`
            );
            console.log(`- formData.customerId: ${formData.customerId}`);

            await triggerDiscountWorkflow(result.data.id, formData.customerId);
          } else {
            console.log(
              "Skipping discount workflow creation in order creation because conditions failed:"
            );
            console.log(
              `- entity is vmco (case insensitive): ${formData.entity &&
              formData.entity.toLowerCase() ===
              Constants.ENTITY.VMCO.toLowerCase()
              }`
            );
            console.log(
              `- productCategory is vmco machines (case insensitive): ${formData.productCategory &&
              formData.productCategory.toLowerCase() ===
              Constants.CATEGORY.VMCO_MACHINES.toLowerCase()
              }`
            );
            console.log(`- has customerID: ${Boolean(formData.customerId)}`);
          } // If we get here, both order and products were saved successfully
          Swal.fire({
            icon: "success",
            title: t("Order Created Successfully!"),
            html: `<div style="text-align: center;">
                    <p style="font-size: 16px; margin-bottom: 10px;">${t(
              "Order and products created successfully!"
            )}</p>
                    <p style="font-size: 18px; font-weight: bold; color: #28a745; margin: 10px 0;">
                        ${t("Order Number")}: #${result.data.id}
                    </p>
                    <p style="font-size: 14px; color: #666;">${t(
              "Please save this order number for your records."
            )}</p>
                  </div>`,
            confirmButtonText: t("OK"),
            confirmButtonColor: "#28a745",
          });
          navigate("/orders");
        } catch (err) {
          console.error("Error saving product lines:", err);
          console.log(
            "Product line items creation failed, so order was deleted"
          );
          // If product lines failed, the order was deleted
          Swal.fire({
            icon: "warning",
            title: t("Error Creating Order"),
            html: `<div style="text-align: center;">
                    <p style="font-size: 16px; margin-bottom: 10px;">${t("Order was deleted because there was an issue adding products.")}</p>
                  </div>`,
            confirmButtonText: t("OK"),
          });
          navigate("/orders");
        }
        break; // Exit the loop on success
      } catch (err) {
        if (attempt >= maxAttempts - 1) {
          setError(err.message);
          Swal.fire({
            icon: "error",
            title: t("Error Saving Order"),
            text: t(err.message),
          });
          // alert(t(err.message));
        }
      } finally {
        setLoading(false);
      }
      attempt++;
    } // Always reset saving state at the end
    setSaving(false);
  };
  // cancel handler
  const handleCancelOrderClick = () => {
    if (!formData.id) {
      Swal.fire({
        icon: 'warning',
        title: t('Validation Error'),
        text: t('Order ID is missing.'),
        confirmButtonText: t("OK")
      });
      return;
    }
    setIsCancelDialogOpen(true);
  };

  const handleCancelOrderSubmit = async (comment) => {
    console.log('Cancelling order with comment:', comment);

    if (!formData.id) {
      Swal.fire({
        icon: 'warning',
        title: t('Validation Error'),
        text: t('Order ID is missing.'),
        confirmButtonText: t("OK")
      });
      return;
    }

    try {
      setCancelling(true);

      // First, update the order status to 'Cancelled'
      const statusResponse = await fetch(`${API_BASE_URL}/sales-order/id/${formData.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          status: 'Cancelled'
        }),
      });

      if (!statusResponse.ok) {
        const errorText = await statusResponse.text();
        console.error('Server response:', errorText);
        try {
          const errorData = JSON.parse(errorText);
          throw new Error(errorData.message || 'Failed to cancel order');
        } catch (e) {
          throw new Error(`Failed to cancel order: ${statusResponse.status} ${statusResponse.statusText}`);
        }
      }

      // Second, add the comment with cancellation details to the comments column
      const commentPayload = {
        comment: comment,
        action: 'Cancelled',
        createdBy: user?.name || user?.username || user?.employeeId,
        createdAt: new Date().toISOString()
      };

      const commentResponse = await fetch(`${API_BASE_URL}/sales-order/id/${formData.id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          comments: JSON.stringify(commentPayload)
        }),
      });

      if (!commentResponse.ok) {
        console.error('Failed to save comment, but order was cancelled');
      }

      Swal.fire({
        icon: 'success',
        title: t('Order Cancelled'),
        text: t('Order cancelled successfully!'),
        confirmButtonText: t("OK")
      });

      navigate('/orders');
    } catch (err) {
      console.error('Error cancelling order:', err);
      Swal.fire({
        icon: 'error',
        title: t('Error Cancelling Order'),
        text: err.message || t('Failed to cancel order'),
        confirmButtonText: t("OK")
      });
    } finally {
      setCancelling(false);
      setIsCancelDialogOpen(false);
    }
  };


  const handleCheckout = async (orderId, email = false, copyUrl = false) => {
    try {
      const { data } = await axios.post(
        `${API_BASE_URL}/generatePayment-link`,
        {
          id: orderId,
          endPoint: "payment-options/order",
          IsEmail: email,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (email) {
        Swal.fire({
          title: t("Payment Link Generated"),
          text: t("A payment link has been sent to the customer's email."),
          icon: "success",
          confirmButtonText: t("OK"),
        });
      } else if (copyUrl) {
        Swal.fire({
          title: t(`Payment Link`),
          html: `
    <div style="display:flex;align-items:center; border:1px solid #ddd; border-radius:4px; overflow:hidden;">
      <input id="payment-link"
             style="flex:1; border:none; padding:10px 12px; font-size:14px; outline:none;"
             type="text"
             value="${data.details.url}"
             readonly />
      <button id="copyBtn"
              style="display:flex; align-items:center; gap:6px; padding:0 12px; height:44px; border:none; border-left:1px solid #ddd; background:#fff; cursor:pointer; transition:all 0.2s; white-space:nowrap;"
              title="Copy to clipboard">
        <i class="fas fa-copy" style="font-size:14px; color:#666;"></i>
        <span id="copyText" style="font-size:14px; color:#666;">Copy</span>
      </button>
    </div>
  `,
          showConfirmButton: false,
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          footer: `
    <div style="display:flex; justify-content:flex-end; gap:10px; width:100%;">
      <button id="sendLinkBtn" class="swal2-confirm swal2-styled" style="background:#009345; display:flex; align-items:center; gap:8px;">
        <i class="fas fa-paper-plane" style="font-size:14px;"></i>
        <span>Send Link</span>
      </button>
      <button id="closeBtn" class="swal2-cancel swal2-styled" style="display:flex; align-items:center; gap:8px;">
        <i class="fas fa-times" style="font-size:14px;"></i>
        <span>Close</span>
      </button>
    </div>
  `,
          didOpen: () => {
            const input = document.getElementById("payment-link");
            const copyBtn = document.getElementById("copyBtn");
            const copyIcon = copyBtn.querySelector('i');
            const copyText = document.getElementById("copyText");
            const sendLinkBtn = document.getElementById("sendLinkBtn");
            const closeBtn = document.getElementById("closeBtn");

            // Hover effect
            copyBtn.addEventListener("mouseenter", () => {
              copyBtn.style.background = "#f5f5f5";
              copyIcon.style.color = "#333";
              copyText.style.color = "#333";
            });

            copyBtn.addEventListener("mouseleave", () => {
              copyBtn.style.background = "#fff";
              copyIcon.style.color = "#666";
              copyText.style.color = "#666";
            });

            // Copy button
            copyBtn.addEventListener("click", async () => {
              input.select();
              input.setSelectionRange(0, 99999);

              try {
                await navigator.clipboard.writeText(input.value);

                // Success state
                copyIcon.className = "fas fa-check";
                copyIcon.style.color = "#28a745";
                copyText.textContent = "Copied!";
                copyText.style.color = "#28a745";
                copyBtn.style.background = "#e8f5e9";
                copyBtn.style.borderLeftColor = "#c3e6cb";

                // Revert after 2 seconds
                setTimeout(() => {
                  copyIcon.className = "fas fa-copy";
                  copyIcon.style.color = "#666";
                  copyText.textContent = t("Copy");
                  copyText.style.color = "#666";
                  copyBtn.style.background = "#fff";
                  copyBtn.style.borderLeftColor = "#ddd";
                }, 2000);
              } catch (err) {
                console.error("Failed to copy: ", err);

                // Error state
                copyIcon.className = "fas fa-times";
                copyIcon.style.color = "#dc3545";
                copyText.textContent = "Failed!";
                copyText.style.color = "#dc3545";
                copyBtn.style.background = "#f8d7da";
                copyBtn.style.borderLeftColor = "#f5c6cb";

                setTimeout(() => {
                  copyIcon.className = "fas fa-copy";
                  copyIcon.style.color = "#666";
                  copyText.textContent = "Copy";
                  copyText.style.color = "#666";
                  copyBtn.style.background = "#fff";
                  copyBtn.style.borderLeftColor = "#ddd";
                }, 2000);
              }
            });

            // Send Link button
            sendLinkBtn.addEventListener("click", () => {
              handleCheckout(orderId, true, false);
              Swal.close();
            });

            // Close button
            closeBtn.addEventListener("click", () => {
              Swal.close();
            });
          },
        });
      } else if (!email && !copyUrl && data?.details?.url) {
        // window.open(data.details.url, "_blank");
        const extracted = data?.details?.url?.split('/payment-options')[1]
        navigate(`/payment-options${extracted}`)
      }
    } catch (error) {
      console.error("Error generating payment link:", error);
      Swal.fire({
        title: t("Error"),
        text: t("Failed to generate payment link. Please try again later."),
        icon: "error",
        confirmButtonText: t("OK"),
      });
    }
  };

  // Images state (allow dynamic add)
  const [images, setImages] = useState(
    Array.isArray(defaultOrder.images) && defaultOrder.images.length > 0
      ? defaultOrder.images.filter(Boolean)
      : []
  );

  // File input ref
  const fileInputRef = useRef(null);

  // Handle image add
  const handleAddImage = (e) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setImages((prev) => [...prev, ev.target.result]);
      };
      reader.readAsDataURL(file);
    }
    e.target.value = "";
  };

  // Open file dialog
  const openFileDialog = () => {
    if (fileInputRef.current) fileInputRef.current.click();
  };

  // Handler for input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "entity" && formMode === "add") {
      // If entity changes in add mode, update payment percentage accordingly
      // Set payment percentage to 100% if entity is not vmco
      const isVmco =
        value.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase();

      setFormData((prev) => ({
        ...prev,
        [name]: value,
        // Set payment percentage to 100% for any entity other than vmco
        paymentPercentage: !isVmco ? "100%" : prev.paymentPercentage || "30%",
      }));
    } else if (name === "category" && formMode === "add") {
      // If category changes in add mode, update payment percentage accordingly
      // and set payment method to "Pre Payment" for "VMCO Machines" category
      const isVmcoMachines = value === Constants.CATEGORY.VMCO_MACHINES;

      setFormData((prev) => ({
        ...prev,
        [name]: value, // Set payment percentage based on category
        paymentPercentage: !isVmcoMachines
          ? "100%"
          : prev.paymentPercentage || "30%",
        // Automatically set paymentMethod to "Pre Payment" for VMCO Machines category
        paymentMethod: isVmcoMachines ? "Pre Payment" : prev.paymentMethod,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // If pricing policy changes, update product prices
    if (name === "pricingPolicy" && formData.customerId) {
      updateProductPricesForPricingPolicy(value);
    }
  };

  const handleEntityChange = (e) => {
    // Check if customer is selected
    if (!formData.customerId && !formData.selectedCustomerName) {
      // No customer selected, show alert
      Swal.fire({
        icon: "warning",
        title: t("Select Customer First"),
        text: t("Please select a customer before choosing an entity."),
        confirmButtonText: t("OK"),
      });
      // Reset the dropdown to empty value
      e.target.value = "";
      return;
    }
    setFormData((prev) => ({
      ...prev, category: ""
    }))

    // Customer is selected, proceed with normal input handling
    handleInputChange(e);
  };

  // Function to update product prices when pricing policy changes
  const updateProductPricesForPricingPolicy = async (pricingPolicy) => {
    if (
      !formData.products ||
      !formData.products.length ||
      !pricingPolicy ||
      !formData.customerId
    ) {
      return;
    }

    try {
      // For each product in the list
      const updatedProducts = [...formData.products];
      const updatePromises = formData.products.map(async (product, index) => {
        // Call API to get updated price for this product with new pricing policy
        const response = await fetch(`${API_BASE_URL}/product/price`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },

          body: JSON.stringify({
            productId: product.id,
            customerId: formData.customerId,
            entity: formData.entity,
            pricingPolicy: pricingPolicy.toLowerCase(),
          }),
        });

        if (response.ok) {
          const result = await response.json();
          if (result.status === "Ok" && result.data) {
            // Update product with new price information
            const unitPrice = Math.floor((result.data.unitPrice || product.unitPrice) * 100) / 100;
            const quantity = parseInt(product.quantity, 10);
            const vatPercentage = Math.floor((result.data.vatPercentage || product.vatPercentage) * 100) / 100;

            // Calculate new net amount with updated price
            const netAmount = roundTo2(unitPrice * quantity + (vatPercentage / 100) * (unitPrice * quantity));

            // Update product in array - RESET lineDiscount to 0.00
            updatedProducts[index] = {
              ...product,
              unitPrice: Math.floor(unitPrice * 100) / 100,
              vatPercentage,
              netAmount,
              lineDiscount: Math.floor(0.00 * 100) / 100,
            };
          }
        }
      });

      // Wait for all product updates to complete
      await Promise.all(updatePromises);

      // Update form data with updated products
      setFormData((prev) => ({
        ...prev,
        products: updatedProducts,
      }));
      setEditingDiscount({});
    } catch (error) {
      console.error("Error updating product prices:", error);
      Swal.fire({
        icon: "error",
        title: t("Error Updating Prices"),
        text: t("Failed to update product prices. Please try again."),
        confirmButtonText: t("OK"),
      });
    }
  };

  // Handle line discount changes
  const handleLineDiscountChange = async (idx, discountPercentage) => {
    const product = formData.products[idx];

    if (!product || !formData.customerId || !formData.entity) {
      console.warn('Missing required data:', {
        hasProduct: !!product,
        customerId: formData.customerId,
        entity: formData.entity
      });
      return;
    }

    const pricingPolicy = formData.pricingPolicy;

    if (!pricingPolicy) {
      console.warn('Pricing policy not found for entity:', formData.entity);
      return;
    }

    console.log('Fetching price for discount change:', {
      productId: product.id,
      customerId: formData?.customerId,
      entity: formData?.entity,
      pricingPolicy: pricingPolicy?.toLowerCase(),
      discount: discountPercentage
    });

    try {
      // Call the API to get the base price
      const response = await fetch(`${API_BASE_URL}/product/price`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          productId: product.id,
          customerId: formData.customerId,
          entity: formData.entity,
          pricingPolicy: pricingPolicy.toLowerCase(),
        }),
      });

      console.log('API Response status:', response.status);

      if (!response.ok) {
        console.error('Failed to fetch product price');
        return;
      }

      const result = await response.json();
      console.log('API Response data:', result);

      if (result.status === "Ok" && result.data) {
        const basePrice = Math.floor(result.data.basePrice * 100) / 100;
        const vatPercentage = Math.floor((product.vatPercentage || 0) * 100) / 100;
        const quantity = parseInt(product.quantity, 10);
        console.log('Base price and VAT for discount calculation:', result?.data);
        // Calculate unit price after discount
        const discountAmount = ((result.data.basePrice - result?.data?.sugarTaxAmount) * discountPercentage) / 100;
        const unitPrice = basePrice - discountAmount;

        // Calculate amounts
        const baseAmount = Math.floor(unitPrice * quantity * 100) / 100;
        const vatAmount = (baseAmount * vatPercentage) / 100;
        const netAmount = roundTo2(baseAmount + vatAmount);

        console.log('Calculated values:', {
          basePrice,
          discountPercentage,
          unitPrice,
          baseAmount,
          vatAmount,
          netAmount
        });

        // Update the product with new values
        setFormData((prev) => {
          const updatedProducts = [...prev.products];
          updatedProducts[idx] = {
            ...updatedProducts[idx],
            lineDiscount: Math.floor(discountPercentage * 100) / 100 || 0.00,
            unitPrice: Math.floor(unitPrice * 100) / 100,
            netAmount: roundTo2(netAmount),
          };
          return {
            ...prev,
            products: updatedProducts,
          };
        });
      }
    } catch (error) {
      console.error('Error fetching product price:', error);
      Swal.fire({
        icon: "error",
        title: t("Error"),
        text: t("Failed to update product price. Please try again."),
        confirmButtonText: t("OK"),
      });
    }
  };

  const isValidLineDiscount = (value) => {
    const num = parseFloat(value);
    console.log("Discount line is:", value, "Parsed number is:", num);
    if (isNaN(num) || num < 0 || num === "undefined") {
      return false;
    }
    return true;
  };

  // Function to update sales order line
  const updateSalesOrderLine = async (
    orderId,
    productId,
    unitPrice,
    quantity,
    netAmount,
    vatPercentage,
    lineDiscount = 0.00
  ) => {
    try {
      // Ensure vatPercentage is 0.00 (decimal) for non trading companies
      let finalVat = vatPercentage;
      if (companyType && companyType.toLowerCase() === "non trading") {
        finalVat = 0.0;
      }

      // Calculate vatAmount (salesTaxAmount)
      const baseAmount = unitPrice * quantity;
      const vatAmount = (baseAmount * finalVat) / 100;

      const response = await fetch(
        `${API_BASE_URL}/sales-order-lines/${orderId}/${productId}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            quantity,
            unitPrice,
            net_amount: roundTo2(netAmount),
            sales_tax_amount: parseFloat(vatAmount * 100).toFixed(2) / 100,
            vatPercentage: Math.floor(finalVat * 100) / 100,
            line_discount: Math.floor(lineDiscount * 100) / 100,
          }),
        }
      );

      if (!response.ok) {
        console.error("Failed to update sales order line");
        const errorText = await response.text();
        console.error("Server response:", errorText);
      } else {
        const updatedLine = await response.json();
        console.log("Successfully updated sales order line:", updatedLine);
      }
    } catch (error) {
      console.error("Error updating sales order line:", error);
    }
  };

  // Function to delete sales order line
  const deleteSalesOrderLine = async (orderId, productId) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/sales-order-lines/${orderId}/${productId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        console.error(
          `Failed to delete sales order line for product ID ${productId}`
        );
        const errorText = await response.text();
        console.error("Server response:", errorText);
      } else {
        console.log(
          `Successfully deleted sales order line for product ID ${productId}`
        );
      }
    } catch (error) {
      console.error(
        `Error deleting sales order line for product ID ${productId}:`,
        error
      );
    }
  };

  // Function to create a new sales order line
  const createSalesOrderLine = async (orderId, productId, erpProdId, unitPrice, quantity, netAmount, vatPercentage, lineDiscount = 0.00) => {
    try {
      // Ensure vatPercentage is 0.00 (decimal) for non trading companies
      let finalVat = vatPercentage;
      if (companyType && companyType.toLowerCase() === "non trading") {
        finalVat = 0.0;
      }

      const baseAmount = unitPrice * quantity;
      const vatAmount = (baseAmount * finalVat) / 100;

      // Find the product object to get productName, productNameLc, unit
      const productObj = formData.products.find((p) => (p.id || p.product_id) === productId);
      const existingLineNumbers = formData.products.map(p => p.lineNumber || 0).filter(lineNum => lineNum > 0);
      const maxLineNumber = existingLineNumbers.length > 0 ? Math.max(...existingLineNumbers) : 0;
      const newLineNumber = maxLineNumber + 1;

      const payload = {
        orderId: orderId,
        lineNumber: newLineNumber,
        erpLineNumber: newLineNumber,
        productId: productId,
        erpProdId: productObj.erpProdId,
        isMachine: productObj?.isMachine,
        isFresh: productObj?.isFresh,
        quantity: parseInt(quantity, 10),
        unitPrice: Math.floor(unitPrice * 100) / 100,
        netAmount: roundTo2(netAmount),
        salesTaxAmount: parseFloat(vatAmount * 100).toFixed(2) / 100,
        productName: productObj?.productName || productObj?.productNameEn,
        productNameLc: productObj?.productNameLc || productObj?.productnamelc,
        unit: productObj?.unit,
        vatPercentage: Math.floor(finalVat * 100) / 100,
        lineDiscount: Math.floor(parseFloat(lineDiscount) * 100) / 100,
      };
      const response = await fetch(`${API_BASE_URL}/sales-order-lines`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },

        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        console.error("Failed to create sales order line");
      }
    } catch (error) {
      console.error("Error creating sales order line:", error);
    }
  };

  // Update the handleSelectProduct function to handle multiple products
  const handleSelectProduct = (products) => {
    // If products is an array (multiple selection), handle each product
    if (Array.isArray(products)) {
      setFormData((prev) => {
        const updatedProducts = [...prev.products];

        products.forEach((product) => {
          // Use MOQ for the product, default to 1 if not set
          const moq = Number(product.moq) || 1;
          // In sample mode, set price to 0, otherwise use the actual price
          const unitPrice = sampleMode ? 0 : Math.floor(product.unitPrice * 100) / 100;
          // Determine VAT based on companyType and sample mode
          let vatPercentage = 0.0;
          if (!sampleMode && companyType && companyType.toLowerCase() === "trading") {
            vatPercentage = Math.floor(product.vatPercentage * 100) / 100;
          }

          // Check if product already exists in the table
          const existingIdx = updatedProducts.findIndex(
            (p) => (p.id || p.product_id) === (product.id || product.product_id)
          );

          if (existingIdx !== -1) {
            // Product exists, increment quantity and update netAmount
            const existingProduct = updatedProducts[existingIdx];
            const newQuantity =
              (parseInt(existingProduct.quantity, 10) || moq) + moq;
            // In sample mode, netAmount is always 0
            const newNetAmount = sampleMode ? "0.00" : roundTo2((unitPrice * newQuantity + (product?.vatPercentage ? (product?.vatPercentage / 100) * (unitPrice * newQuantity) : 0)));
            updatedProducts[existingIdx] = {
              ...existingProduct,
              quantity: newQuantity,
              netAmount: roundTo2(newNetAmount),
              moq: moq,
              vatPercentage: product.vatPercentage,
              unitPrice: sampleMode ? "0.00" : existingProduct.unitPrice,
              productName: product.productName,
              productNameLc: product.productNameLc,
              isMachine: product.isMachine || product.is_machine || false,
              isFresh: product.isFresh || false,
              lineDiscount: "0.00"
            };
          } else {
            // Product does not exist, add as new row with MOQ as quantity and line discount as 0.00
            // In sample mode, netAmount is always 0
            const netAmount = sampleMode ? "0.00" : roundTo2((unitPrice * moq + (product?.vatPercentage ? (product?.vatPercentage / 100) * (unitPrice * moq) : 0)));

            const newProduct = {
              id: product.id,
              product_id: product.id,
              productName: product.productName,
              productNameLc: product.productNameLc,
              erpProdId: product.erpProdId || product.erp_prod_id || "",
              quantity: sampleMode ? 1 : moq,
              unit: product.unit,
              isMachine: product.isMachine || product.is_machine || false,
              isFresh: product.isFresh || false,
              // In sample mode, unitPrice is always 0
              unitPrice: sampleMode ? "0.00" : roundTo2(unitPrice),
              netAmount: roundTo2(netAmount),
              vatPercentage: sampleMode ? "0.00" : roundTo2(product.vatPercentage),
              moq: sampleMode ? 1 : moq,
              lineDiscount: "0.00"
            };
            updatedProducts.push(newProduct);
          }
        });

        return {
          ...prev,
          products: updatedProducts,
        };
      });
    }
    setShowProductPopup(false);
  };

  // Handle customer selection
  const handleSelectCustomer = (customer) => {
    console.log("Selected customer:", customer);

    // Handle assignedToEntityWise which could be an object or a JSON string
    let assignedToEntityWise = {};
    if (customer.assignedToEntityWise) {
      try {
        // Check if it's already an object
        if (
          typeof customer.assignedToEntityWise === "object" &&
          customer.assignedToEntityWise !== null
        ) {
          assignedToEntityWise = customer.assignedToEntityWise;
        } else {
          // It's a string, try to parse it
          assignedToEntityWise = JSON.parse(customer.assignedToEntityWise);
        }
        console.log("Processed assignedToEntityWise:", assignedToEntityWise);
      } catch (error) {
        console.error("Error processing assignedToEntityWise:", error);
        assignedToEntityWise = {};
      }
    }

    // Format the current user's employee ID to match the format in assignedToEntityWise
    const currentEmployeeId = formatEmployeeId(user?.employeeId);
    console.log("Current formatted employee ID:", currentEmployeeId);

    let customerUnblockedUntil = "";
    if (customer.unblockedUntil) {
      customerUnblockedUntil = new Date(customer.unblockedUntil);
    }

    const userAllowedEntities = [];
    if (currentEmployeeId && assignedToEntityWise) {
      // Find entities where this employee is assigned
      Object.entries(assignedToEntityWise).forEach(([entity, empId]) => {
        if (empId === currentEmployeeId) {
          userAllowedEntities.push(entity);
        }
      });
    }

    console.log("User allowed entities:", userAllowedEntities);
    setAllowedEntities(userAllowedEntities);

    // Ensure the pricing policy is one of the allowed options and never undefined
    let customerPricingPolicy = customer.pricingPolicy;

    // Check if customer.pricingPolicy exists in ENGLISH options (by ID)
    const englishPricingPolicyIds = pricingPolicyEnOptions.map(option => option.value);

    if (
      !customerPricingPolicy ||
      customerPricingPolicy === "" ||
      !englishPricingPolicyIds.includes(customerPricingPolicy)
    ) {
      customerPricingPolicy = "";
      console.log(`Invalid pricing policy for customer: ${customer.pricingPolicy}. Reset to empty.`);
    }
    setCompanyType(
      customer.companyType || (customer.data && customer.data.companyType) || ""
    );
    setFormData((prev) => ({
      ...prev,
      erpCustId: customer.erp_cust_id || customer.erpCustId || "", // Handle both property naming formats
      customerId: customer.id, // Use the database ID for the customer
      selectedCustomerName:
        i18n.language === "ar"
          ? customer.company_name_ar || customer.companyNameAr
          : customer.company_name_en || customer.companyNameEn,
      pricingPolicy: customer.pricingPolicy,
      companyNameEn: customer.company_name_en || customer.companyNameEn || "",
      companyNameAr: customer.company_name_ar || customer.companyNameAr || "",
      brandNameEn: customer.brand_name_en || customer.brandNameEn || "",
      brandNameAr: customer.brand_name_ar || customer.brandNameAr || "",
      salesExecutive: customer.assignedToEntityWise,
      assignedToEntityWise: assignedToEntityWise,
      customerRegion: customer.region || "",
      customerUnblockedUntil: customer.unblockedUntil,
    }));
    console.log("Updated form data with customer information", formData);
    setFormData((prev) => ({
      ...prev,
      branchId: null, // Set branchId (important for API calls)
      erpBranchId: null,
      selectedBranchName: null,
      branchNameEn: null, // Set branchNameEn
      branchNameLc: null, // Set branchNameLc
      branchRegion: null, // Set branchRegion
      branchCity: null, // Set branchCity
    }));

    setShowCustomerPopup(false);
  };
  // Handle branch selection
  const handleSelectBranch = (branch) => {
    console.log("Selected branch data:", branch);
    setFormData((prev) => ({
      ...prev,
      branchId: branch.id, // Set branchId (important for API calls)
      erpBranchId: branch.erp_branch_id || branch.erpBranchId,
      selectedBranchName: branch.branch_name_en || branch.branchNameEn || "",
      branchNameEn: branch.branch_name_en || branch.branchNameEn || "", // Set branchNameEn
      branchNameLc: branch.branch_name_lc || branch.branchNameLc || "", // Set branchNameLc
      branchRegion: branch.region, // Set branchRegion
      branchCity: branch.city, // Set branchCity
    }));
    console.log("Updated form data with branch information");
    setShowBranchPopup(false);
  };

  // Add this to your state declarations section near the top of the component
  const [allowedEntities, setAllowedEntities] = useState([]);

  // Add this function inside the OrderDetails component, before the return statement
  // Function to format employee ID to match assignedToEntityWise format
  const formatEmployeeId = (id) => {
    if (!id) return "";
    // If it already has the format emp_XXXX, return as is
    if (typeof id === "string" && id.startsWith("emp_")) return id;
    // Otherwise, add the prefix
    return `emp_${id}`;
  };

  // Add this to your existing state declarations
  const [entityOptions, setEntityOptions] = useState([]);
  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);

  useEffect(() => {
    if (loading) {
      return;
    }

    if (!user) {
      console.log("$$$$$$$$$$$ logging out");
      // // Logout instead of showing loading message
      // logout();
      // navigate('/login');
      // return; // Return while logout is processing
    }

    if (user && user.userType) {
      const fetchData = async () => {
        if (formMode === "add") {
          setLoading(false);
          return;
        }
        // Always fetch order details by ID, which will also fetch products
        await getOrderById(orderFromNav.id);
      };
      fetchData();
    }
  }, [user, t, token, i18n.language, orderFromNav.id, formMode, loading]);

  // Initialize RBAC manager
  const rbacMgr = new RbacManager(
    user?.userType === "employee" && user?.roles[0] !== "admin"
      ? user?.designation
      : user?.roles[0],
    formMode === "add" ? "orderDetailAdd" : "orderDetailEdit"
  );
  const isV = rbacMgr.isV.bind(rbacMgr);
  const isE = rbacMgr.isE.bind(rbacMgr);

  // Function to handle Product Stock Availability
  const handleStock = async (productId, productName) => {
    setLoadingProductId(productId);
    try {
      setInventoryLoading(true);
      const { data } = await axios.get(
        `${API_BASE_URL}/product-inventory-avalability/${productId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setProductName(productName);
      setInventoryData(data?.details || []);
      setInventoryLoading(false);
      setShowInventory(true);
    } catch (error) {
      console.error("Error fetching stock information:", error);
      Swal.fire({
        icon: "error",
        title: t("Error Fetching Stock"),
        text: t("Failed to fetch stock information for the product."),
        confirmButtonText: t("OK"),
      });
    } finally {
      setInventoryLoading(false);
    }
  };
  // Define columns for the products DataGrid
  const productColumns = [
    {
      field: "erpProdId",
      headerName: t("Product ID"),
      include: isV("productIdCol"),
      minWidth: 80,
      flex: 1,
    },
    {
      field: "productName",
      headerName: t("Product Name"),
      include: isV("productNameCol"),
      minWidth: 140,
      flex: 2,
      renderCell: (params) => {
        const row = params.row;
        return i18n.language === "ar"
          ? row.productNameLc || row.product_name_lc || row.productName
          : row.productName || row.product_name_en || row.productNameLc;
      },
    },
    {
      field: "quantity",
      headerName: t("Quantity"),
      include: isV("quantityCol"),
      minWidth: 180,
      flex: 1,
      renderCell: (params) => {
        const row = params.row;
        const idx = formData.products.findIndex(
          (p) => (p.id || p.productid) === (row.id || row.productid)
        );

        return (
          <div
            className="quantity-controller"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <QuantityController
              itemId={row.id || row.productid}
              quantity={row.quantity}
              moq={Number(row.moq) || 1}
              minQuantity={Number(row.moq) || 1}
              disabled={!isE("quantityCol")}
              onQuantityChange={(itemId, delta) => {
                if (!isE("quantityCol")) return;

                if (idx !== -1) {
                  const currentQty =
                    parseInt(formData.products[idx].quantity) || 0;
                  const newQty = Math.max(0, currentQty + delta);
                  handleQuantityChange(idx, newQty);
                }
              }}
              onInputChange={(itemId, value) => {
                if (!isE("products")) return;

                if (idx !== -1) {
                  // Allow any input value - let QuantityController handle validation
                  handleQuantityChange(idx, value === "" ? "" : value);
                }
              }}
            />
            {/* Stock button for VMCO entity */}
            {isV("stock") &&
              formData.entity &&
              formData.entity.toLowerCase() ===
              Constants.ENTITY.VMCO.toLowerCase() && (
                <span>
                  <button
                    type="button"
                    style={{
                      background: "#e6f2ef",
                      color: "#0a5640",
                      border: "1px solid #0a5640",
                      borderRadius: "4px",
                      fontSize: "12px",
                      padding: "2px 8px",
                      marginLeft: "6px",
                      marginRight: "6px",
                      cursor: "pointer",
                    }}
                    title={row.unit ? `Stock for ${row.unit}` : "Stock"}
                    onClick={() =>
                      handleStock(
                        row.id,
                        i18n.language === "ar"
                          ? row.productNameLc ||
                          row.productnamelc ||
                          row.productName
                          : row.productName ||
                          row.productnameen ||
                          row.productNameLc
                      )
                    }
                  >
                    {t("Stock")}
                  </button>
                </span>
              )}
            {InventoryLoading && loadingProductId === row.id && (
              <LoadingSpinner />
            )}
          </div>
        );
      },
    },
    {
      field: "unit",
      headerName: t("Unit"),
      include: isV("unitCol"),
      minWidth: 80,
      flex: 1,
    },
    {
      field: "unitPrice",
      headerName: t("Unit Price (SAR)"),
      include: isV("unitPriceCol"),
      minWidth: 120,
      flex: 1,
      renderCell: (params) => {
        const price = parseFloat(params.value || 0);
        return Math.floor(price * 100) / 100;
      },
    },
    {
      field: "lineDiscount",
      headerName: t("Discount"),
      include: formData.entity?.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase(),
      minWidth: 120,
      flex: 1,
      renderCell: (params) => {
        const row = params.row;
        const idx = formData.products.findIndex(
          (p) => (p.id || p.productid) === (row.id || row.productid)
        );
        const productKey = row.id || row.productid;

        const displayValue =
          editingDiscount[productKey] !== undefined
            ? editingDiscount[productKey]
            : row.lineDiscount || 0.00;
        const isEditable = fromApproval;

        return (
          <input
            type="number"
            value={displayValue}
            onChange={(e) => {
              if (!isEditable) return;

              const value = e.target.value;
              // Update local state immediately for smooth typing
              setEditingDiscount((prev) => ({
                ...prev,
                [productKey]: value,
              }));
            }}
            onBlur={(e) => {
              if (!isEditable) return;

              const value = parseFloat(e.target.value);

              // Validate range
              if (isNaN(value) || value < 0 || value > 100) {
                // Reset to original value if invalid
                setEditingDiscount((prev) => {
                  const newState = { ...prev };
                  delete newState[productKey];
                  return newState;
                });
                return;
              }

              if (idx !== -1) {
                console.log("Line discount changed for index", idx, "value:", value);
                handleLineDiscountChange(idx, value);
                setEditingDiscount((prev) => {
                  const newState = { ...prev };
                  delete newState[productKey];
                  return newState;
                });
              }
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                e.target.blur();
              }
            }}
            disabled={!isEditable}
            min={0}
            max={100}
            step={0.01}
            style={{
              textAlign: "center",
              padding: "4px 8px",
              fontSize: "14px",
              width: "100%",
              maxWidth: "80px",
              border: "1px solid #ddd",
              borderRadius: "4px",
              cursor: isEditable ? "text" : "not-allowed",
              backgroundColor: isEditable ? "#fff" : "#f5f5f5",
              color: isEditable ? "#000" : "#999",
            }}
          />
        );
      },
    },
    {
      field: "vatPercentage",
      headerName: t("VAT"),
      include: isV("vatPercentageCol"),
      minWidth: 50,
      flex: 1,
      renderCell: (params) => {
        return (params.value || 0) + "%";
      },
    },
    {
      field: "netAmount",
      headerName: t("Net Amount (SAR)"),
      include: isV("netAmountCol"),
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return roundTo2(params.value) || 0;
      },
    },
    ...(isE("deleteCol")
      ? [
        {
          field: "actions",
          headerName: t("Actions"),
          include: isV("deleteButton"),
          minWidth: 100,
          flex: 1,
          sortable: false,
          disableColumnMenu: true,
          renderCell: (params) => {
            const row = params.row;
            const idx = formData.products.findIndex(
              (p) => (p.id || p.productid) === (row.id || row.productid)
            );

            return (
              isV("deleteButton") &&
              isE("deleteCol") && (
                <button
                  className="order-action-btn reject"
                  style={{ padding: "4px 10px", fontSize: 14 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteProductRow(idx);
                  }}
                  type="button"
                  disabled={
                    !isE("deleteButton") ||
                    (formData.status &&
                      !["open"].includes(formData.status.toLowerCase()))
                  }
                >
                  {t("Delete")}
                </button>
              )
            );
          },
        },
      ]
      : []),
  ];

  // Filter visible columns
  const visibleProductColumns = productColumns.filter(
    (col) => col.include !== false
  );

  // Add this useEffect to fetch entity options
  useEffect(() => {
    const fetchEntityOptions = async () => {
      try {
        // Updated URL to include query parameter for entity master type
        const response = await fetch(
          `${API_BASE_URL}/basics-masters?filters={"masterName": "entity"}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch entity options");

        const result = await response.json();

        if (result.status === "Ok" && result.data) {
          const options = result.data;
          // Extract entity values from the response data
          const entityValues = options.map((item) => item.value);
          setEntityOptions(entityValues);
        } else if (result.data && Array.isArray(result.data)) {
          const options = result.data;
          // Handle the actual response structure we're seeing in the logs
          const entityValues = options.map((item) => item.value);
          setEntityOptions(entityValues);
        } else {
          throw new Error("Unexpected response format for entity options");
        }
      } catch (err) {
        console.error("Error fetching entity options:", err);
      }
    };

    fetchEntityOptions();
  }, []);

  // Add this to your existing state declarations
  // eslint-disable-next-line
  const [customerOptions, setCustomerOptions] = useState([]);

  // Add this useEffect to fetch customer options when the GetCustomers component is opened
  useEffect(() => {
    // This function only needs to be kept if you want to pass it to a child component
    const fetchCustomerOptions = async () => {
      try {
        const params = new URLSearchParams({
          page: 1,
          pageSize: 10, // Fetch a reasonable number of customers
          sortBy:
            i18n.language === "ar" ? "company_name_ar" : "company_name_en",
          sortOrder: "asc",
          purpose: "order creation",
        });
        console.log(
          "Fetching customer options with params:",
          params.toString()
        );
        const response = await fetch(
          `${API_BASE_URL}/customers/pagination?${params.toString()}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch customer options");

        const result = await response.json();
        console.log("Customer options response:", result);
        if (
          result.status === "Ok" &&
          result.data &&
          Array.isArray(result.data.data)
        ) {
          setCustomerOptions(result.data.data);
        } else {
          throw new Error("Unexpected response format for customer options");
        }
      } catch (err) {
        console.error("Error fetching customer options:", err);
        // Fallback to empty array if the API call fails
        setCustomerOptions([]);
      }
    };

    // Only fetch if the popup is open
    if (showCustomerPopup) {
      fetchCustomerOptions();
    }
  }, [showCustomerPopup, i18n.language]);

  // Add this useEffect to fetch payment method options
  useEffect(() => {
    const fetchPaymentMethodOptions = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/basics-masters?filters={"masterName": "paymentMethod"}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok)
          throw new Error("Failed to fetch payment method options");

        const result = await response.json();

        if (result.status === "Ok" && result.data) {
          const options = result.data;
          // Extract payment method values from the response data
          const paymentMethodValues = options.map((item) => item.value);
          setPaymentMethodOptions(paymentMethodValues);
        } else if (result.data && Array.isArray(result.data)) {
          const options = result.data;
          // Handle the actual response structure we're seeing in the logs
          const paymentMethodValues = options.map((item) => item.value);
          setPaymentMethodOptions(paymentMethodValues);
        } else {
          throw new Error(
            "Unexpected response format for payment method options"
          );
        }
      } catch (err) {
        console.error("Error fetching payment method options:", err);
      }
    };

    fetchPaymentMethodOptions();
  }, []);
  // In edit mode, show the totalAmount from the sales order data
  // DO NOT include delivery charges in the totalAmount calculation

  useEffect(() => {
    // If it's a sample order, always set values to 0.00
    if (sampleMode || formData.sample_order) {
      setFormData((prev) => ({
        ...prev,
        deliveryCharges: "0.00",
        totalAmount: "0.00",
      }));
      return;
    }

    // In EDIT MODE: Use the existing totalAmount from the sales order
    if (formMode === "edit" && formData.id) {
      // Don't recalculate totalAmount in edit mode
      // totalAmount stays as-is from the order
      console.log("Edit mode: Using existing totalAmount:", formData.totalAmount);
      return;
    }

    // In ADD MODE: Calculate totalAmount from products
    if (Array.isArray(formData.products) && formData.products.length > 0) {
      // Since netAmount already includes VAT, just sum the netAmount values
      const netTotalWithVAT = formData.products.reduce((sum, p) => {
        const net = roundTo2(p.netAmount) || 0;
        return sum + net;
      }, 0);

      // Final total = net with VAT (delivery charges NOT included)
      const finalTotal = netTotalWithVAT;

      // Update only if values have changed
      if (formData.totalAmount !== Math.floor(finalTotal * 100) / 100) {
        setFormData((prev) => ({
          ...prev,
          totalAmount: roundTo2(finalTotal),
        }));
      }
    } else {
      // No products, set everything to 0
      if (formData.totalAmount !== "0.00") {
        setFormData((prev) => ({
          ...prev,
          totalAmount: "0.00",
        }));
      }
    }
  }, [formData.products, formMode, formData.id, sampleMode, formData.sample_order]);


  // Set payment percentage based on category
  useEffect(() => {
    // Only auto-set payment percentage in add mode
    if (formMode === "add") {
      // For initial load or when category changes
      if (formData.category && formData.category !== "VMCO Machines") {
        // For non-VMCO Machines categories, set default to 100%
        setFormData((prev) => ({
          ...prev,
          paymentPercentage: 100,
        }));
      }
    }
  }, [formMode, formData.category]);

  // Fetch order products
  useEffect(() => {
    async function fetchOrderProducts() {
      try {
        const params = new URLSearchParams({
          page: 1,
          pageSize: 10000,
          search: "",
          sortBy: "id",
          sortOrder: "asc",
          filters: JSON.stringify({ order_id: orderId }),
        });

        const url = `${API_BASE_URL}/sales-order-lines/pagination?${params.toString()}`;
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error("Failed to fetch order products");

        const result = await response.json();
        if (
          result.status === "Ok" &&
          result.data &&
          Array.isArray(result.data.data)
        ) {
          // Map the product data to ensure we use productName instead of erpProdId
          const processedProducts = result.data.data.map((product) => ({
            ...product,
            id: product.productId,
            productName:
              product.productName ||
              product.product_name ||
              product.erp_prod_id,
            isMachine: product.isMachine,
            isFresh: product.isFresh,
            quantity: product.quantity,
            imageUrl: product.images[0] || ""
          }));

          setFormData((prev) => ({
            ...prev,
            products: processedProducts,
          }));

          // Store the original product list for comparison when saving
          setOriginalProducts(processedProducts);
          console.log(
            "Stored original products for comparison:",
            processedProducts
          );
        }
      } catch (err) {
        console.error("Error fetching order products:", err);
      }
    }

    if (orderId) {
      fetchOrderProducts();
    }
  }, [orderId]);

  useEffect(() => {
    const fetchPricingPolicyOptions = async () => {
      if (!formData.entity) {
        setPricingPolicyEnOptions([]);
        setPricingPolicyArOptions([]);
        return;
      }

      try {
        // Fix the URL - use proper query parameter format
        const response = await fetch(
          `${API_BASE_URL}/pricing-policy/pagination?entity=${formData.entity}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch pricing policies');
        }

        const result = await response.json();

        if (result.status === 'Ok' && result.data && Array.isArray(result.data.data)) {
          // Separate English and Arabic options
          const enOptions = result.data.data.map(item => ({
            value: item.name,
            label: item.name
          }));

          const arOptions = result.data.data.map(item => ({
            value: item.name,
            label: item.nameLc
          }));

          setPricingPolicyEnOptions(enOptions);
          setPricingPolicyArOptions(arOptions);
        } else {
          console.warn('Unexpected pricing policy response format:', result);
          setPricingPolicyEnOptions([]);
          setPricingPolicyArOptions([]);
        }
      } catch (error) {
        console.error('Error fetching pricing policies:', error);
        setPricingPolicyEnOptions([]);
        setPricingPolicyArOptions([]);
      }
    };

    fetchPricingPolicyOptions();
  }, [formData.entity, token]);

  // Function to get order details by ID
  const getOrderById = async (id) => {
    if (!id) return;

    try {
      const response = await fetch(`${API_BASE_URL}/sales-order/id/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch order details");
      const result = await response.json();
      if (result.status === "Ok" && result.data) {
        console.log("Order details received in getOrderById:", result.data);
        setFormData({
          ...result.data,
          expectedDeliveryDate: result.data.expectedDeliveryDate || "",
          products: result.data.products || [],
        }); // Also fetch the order lines by updating orderId which triggers useEffect
        setOrderId(id);
      } else {
        throw new Error(result.message || "Order not found");
      }
    } catch (err) {
      console.error("Error fetching order details:", err);
      setError(err.message);
    }
  };

  // Note: checkWorkflowInstance function removed as we're now directly creating workflow instances
  // Function to directly create a discount workflow instance regardless of whether one already exists
  const triggerDiscountWorkflow = async (orderId, customerId) => {
    try {
      // Validate inputs with detailed checking
      if (!orderId || orderId === null || orderId === undefined) {
        console.error(
          "Missing or invalid orderId in triggerDiscountWorkflow:",
          orderId
        );
        return false;
      }

      if (!customerId || customerId === null || customerId === undefined) {
        console.error(
          "Missing or invalid customerId in triggerDiscountWorkflow:",
          customerId
        );
        return false;
      }

      // Validate required environment variables and auth
      if (!API_BASE_URL) {
        console.error(
          "API_BASE_URL is not defined. Check your environment variables."
        );
        return false;
      }

      if (!token) {
        console.error(
          "Authentication token is not available. User may not be logged in."
        );
        return false;
      }

      // Ensure values are properly converted to strings and are valid
      let orderIdStr, customerIdStr;

      try {
        orderIdStr = String(orderId).trim();
        customerIdStr = String(customerId).trim();
      } catch (err) {
        console.error("Error converting IDs to strings:", err);
        return false;
      }

      // Final validation of string conversion
      if (!orderIdStr || orderIdStr === "null" || orderIdStr === "undefined") {
        console.error("OrderId converted to invalid string:", orderIdStr);
        return false;
      }

      if (
        !customerIdStr ||
        customerIdStr === "null" ||
        customerIdStr === "undefined"
      ) {
        console.error("CustomerId converted to invalid string:", customerIdStr);
        return false;
      }
      const payload = {
        customerId: customerIdStr,
        salesOrderId: orderIdStr,
      };

      // Final payload validation
      console.log("Final payload validation:");
      console.log("- payload:", JSON.stringify(payload));
      console.log("- customerId length:", customerIdStr.length);
      console.log("- salesOrderId length:", orderIdStr.length);

      // Ensure payload values are not empty strings
      if (!payload.customerId || !payload.salesOrderId) {
        console.error("Payload contains empty strings:", payload);
        return false;
      }

      console.log("Directly creating discount workflow with payload:", payload);
      console.log(
        `API URL: ${API_BASE_URL}/workflow-instance/create/vmco/machines/discount`
      );
      console.log("Token available:", !!token);

      // Note: The backend should handle duplicate workflow instances gracefully
      const response = await fetch(
        `${API_BASE_URL}/workflow-instance/create/vmco/machines/discount`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Adding Authorization header with token
          },
          body: JSON.stringify(payload),
        }
      );

      console.log("Discount workflow API response status:", response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(
          `Error triggering discount workflow (status: ${response.status}):`,
          errorText
        );
        try {
          // Try to parse the error as JSON for more details
          const errorJson = JSON.parse(errorText);
          console.error("Error details:", errorJson);
        } catch (e) {
          // If parsing fails, just log the raw text
          console.error("Raw error response:", errorText);
        }
        return false;
      }

      const result = await response.json();
      console.log("Discount workflow triggered successfully:", result);
      return true;
    } catch (err) {
      console.error("Error triggering discount workflow (exception):", err);
      console.error(err.stack || "No stack trace available");
      return false;
    }
  };

  // Function to trigger VMCO consumables discount workflow
  const triggerConsumablesDiscountWorkflow = async (orderId, customerId) => {
    try {
      // Validate inputs
      if (!orderId || orderId === null || orderId === undefined) {
        console.error(
          "Missing or invalid orderId in triggerConsumablesDiscountWorkflow:",
          orderId
        );
        return false;
      }

      if (!customerId || customerId === null || customerId === undefined) {
        console.error(
          "Missing or invalid customerId in triggerConsumablesDiscountWorkflow:",
          customerId
        );
        return false;
      }

      if (!API_BASE_URL) {
        console.error(
          "API_BASE_URL is not defined. Check your environment variables."
        );
        return false;
      }

      if (!token) {
        console.error(
          "Authentication token is not available. User may not be logged in."
        );
        return false;
      }

      // Convert IDs to strings
      let orderIdStr, customerIdStr;

      try {
        orderIdStr = String(orderId).trim();
        customerIdStr = String(customerId).trim();
      } catch (err) {
        console.error("Error converting IDs to strings:", err);
        return false;
      }

      // Validate converted strings
      if (!orderIdStr || orderIdStr === "null" || orderIdStr === "undefined") {
        console.error("OrderId converted to invalid string:", orderIdStr);
        return false;
      }

      if (
        !customerIdStr ||
        customerIdStr === "null" ||
        customerIdStr === "undefined"
      ) {
        console.error("CustomerId converted to invalid string:", customerIdStr);
        return false;
      }

      const payload = {
        customerId: customerIdStr,
        salesOrderId: orderIdStr,
      };

      const response = await fetch(
        `${API_BASE_URL}/workflow-instance/create/vmco/consumables/discount`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      console.log("Consumables discount workflow API response status:", response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error(
          `Error triggering consumables discount workflow (status: ${response.status}):`,
          errorText
        );
        try {
          const errorJson = JSON.parse(errorText);
          console.error("Error details:", errorJson);
        } catch (e) {
          console.error("Raw error response:", errorText);
        }
        return false;
      }

      const result = await response.json();
      console.log("Consumables discount workflow triggered successfully:", result);
      return true;
    } catch (err) {
      console.error("Error triggering consumables discount workflow (exception):", err);
      console.error(err.stack || "No stack trace available");
      return false;
    }
  };

  //discount approval code block end -----------------------------------------------------------------------------------------------------

  const handleApprovalSubmit = (action) => {
    if (fromApproval && action === "approve" && !formData.erpWarehouseId) {
      Swal.fire({
        icon: 'warning',
        title: t('Warehouse Required'),
        text: t('Please select a warehouse before approving.'),
        confirmButtonText: t("OK"),
      });
      return;
    }

    if (fromApproval && action === "approve" && formData.products.some(p => !isValidLineDiscount(p.lineDiscount))) {
      Swal.fire({
        icon: 'warning',
        title: t('Invalid Line Discount'),
        text: t('Please enter a valid line discount for all products.'),
        confirmButtonText: t("OK"),
      });
      return;
    }

    setApprovalAction(action);
    setIsApprovalDialogOpen(true);
  };
  const handleDialogSubmit = async (comment) => {

    let updates = {
      ...((location.state?.workflowData &&
        location.state.workflowData.updates) ||
        {}),
    };

    try {
      // Ensure we have the latest order data
      console.log("Getting latest order data before proceeding with approval");
      await getOrderById(formData.id);

      // STEP 1: First update sales order lines and sales order if needed
      // --- BEGIN: PATCH order lines and order if approving in approval mode and status is pending ---
      if (
        approvalAction === "approve" &&
        fromApproval &&
        formData.status &&
        formData.status.toLowerCase() === "pending"
      ) {
        try {
          console.log(
            "Updating sales order lines and sales order before approval"
          );

          // 1. Update existing sales order lines and create new ones
          for (const product of formData.products) {
            const productId = product.id || product.product_id;
            const unitPrice = Math.floor(product.unitPrice * 100) / 100;
            const quantity = parseInt(product.quantity, 10);
            const netAmount = Math.floor(product.netAmount * 100) / 100;
            const vatPercentage = Math.floor(product.vatPercentage * 100) / 100;
            const lineDiscount = Math.floor(product.lineDiscount * 100) / 100;

            // Check if this product exists in the original products (was part of the original order)
            const existsInOriginal = originalProducts.some(
              (originalProduct) =>
                (originalProduct.id || originalProduct.product_id) === productId
            );
            if (existsInOriginal) {
              // Product exists in original order - PATCH to update it
              console.log(`Updating existing product line: ${productId}`);
              const patchResponse = await fetch(
                `${API_BASE_URL}/sales-order-lines/${formData.id}/${productId}`,
                {
                  method: "PATCH",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                  body: JSON.stringify({
                    quantity,
                    unitPrice,
                    net_amount: netAmount,
                    vatPercentage: vatPercentage,
                    lineDiscount: lineDiscount
                  }),
                }
              );

              if (!patchResponse.ok) {
                const errorText = await patchResponse.text();
                throw new Error(
                  `Failed to update product line ${productId}: ${errorText}`
                );
              }
            } else {
              // Product is new - POST to create it
              console.log(`Creating new product line: ${productId}`);
              const postResponse = await fetch(
                `${API_BASE_URL}/sales-order-lines`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                  },
                  body: JSON.stringify({
                    orderId: formData.id,
                    productId: productId,
                    productName: product.productName || product.product_name_en || "",
                    productNameLc: product.productNameLc || product.product_name_lc || "",
                    isMachine: product.isMachine,
                    isFresh: product.isFresh,
                    quantity,
                    unitPrice,
                    net_amount: netAmount,
                    vatPercentage: product.vatPercentage,
                    erpProdId: product.erpProdId || product.erp_prod_id || "",
                    unit: product.unit || "",
                    lineDiscount: product.lineDiscount || 0.00
                  }),
                }
              );

              if (!postResponse.ok) {
                const errorText = await postResponse.text();
                throw new Error(
                  `Failed to create new product line ${productId}: ${errorText}`
                );
              }
            }
          }

          const patchPayload = {
            totalAmount: formData.totalAmount,
            paymentPercentage: formData.paymentPercentage
              ? formData.paymentPercentage === "100%" ? "100.00" : formData.paymentPercentage === "30%"
                ? "30.00" : "0.00" : "0.00",
          };

          if (formData.erpWarehouseId) {
            patchPayload.erpWarehouseId = formData.erpWarehouseId;
          }
          if (formData.warehouseNameEn) {
            patchPayload.warehouseNameEn = formData.warehouseNameEn;
          }
          if (formData.warehouseNameAr) {
            patchPayload.warehouseNameAr = formData.warehouseNameAr;
          }

          if (formData.pricingPolicy) {
            patchPayload.pricingPolicy = formData.pricingPolicy;
          }

          if (formData.lineDiscount) {
            patchPayload.lineDiscount = formData.lineDiscount;
          }

          const orderUpdateResponse = await fetch(
            `${API_BASE_URL}/sales-order/id/${formData.id}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify(patchPayload),
            }
          );

          if (!orderUpdateResponse.ok) {
            const errorText = await orderUpdateResponse.text();
            throw new Error(`Failed to update sales order: ${errorText}`);
          }

          console.log("Successfully updated sales order lines and sales order");
        } catch (err) {
          Swal.fire({
            icon: "error",
            title: t("Error Updating Order"),
            text:
              t("Failed to update order or lines before approval: ") +
              (err.message || err),
            confirmButtonText: t("OK"),
          });
          return;
        }
      }

      // --- END: PATCH order lines and order if approving in approval mode and status is pending ---
      // STEP 2: Directly create discount workflow without checking if it exists
      console.log("Creating discount workflow instance...");
      console.log("formData:", {
        id: formData.id,
        entity: formData.entity,
        productCategory: formData.productCategory,
        customerId: formData.customerId,
      });

      // Additional debugging for the IDs
      console.log("Detailed formData validation:");
      console.log(
        `- formData.id type: ${typeof formData.id}, value: ${formData.id}`
      );
      console.log(
        `- formData.customerId type: ${typeof formData.customerId}, value: ${formData.customerId
        }`
      ); // Use case-insensitive comparison for entity
      if (
        formData.entity &&
        formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase() &&
        formData.isMachine &&
        formData.isMachine === true &&
        formData.customerId &&
        formData.id
      ) {
        // Additional validation before calling the workflow
        if (
          formData.id &&
          formData.customerId &&
          formData.id !== null &&
          formData.id !== undefined &&
          formData.customerId !== null &&
          formData.customerId !== undefined
        ) {
          console.log(
            `Directly triggering discount workflow for order ${formData.id} with customer ${formData.customerId}`
          );
          const workflowTriggered = await triggerDiscountWorkflow(
            formData.id,
            formData.customerId
          );
          console.log(`Discount workflow triggered: ${workflowTriggered}`);
        } else {
          console.error(
            "Cannot trigger discount workflow - invalid ID values:"
          );
          console.error(
            `- orderId: ${formData.id} (type: ${typeof formData.id})`
          );
          console.error(
            `- customerId: ${formData.customerId
            } (type: ${typeof formData.customerId})`
          );
        }
      } else {
        console.log(
          "Skipping discount workflow - not a VMCO Machines order or missing customer ID"
        );
        console.log(`- entity: ${formData.entity}`);
        console.log(
          `- entity.toLowerCase() === 'vmco': ${formData.entity &&
          formData.entity.toLowerCase() ===
          Constants.ENTITY.VMCO.toLowerCase()
          }`
        );
        console.log(`- isMachine is: ${formData.isMachine}`);
        console.log(`- customerId: ${Boolean(formData.customerId)}`);
      }

      // After updating sales order lines in handleDialogSubmit, add this check:
      // Check if any product has line discount > 0 for VMCO consumables
      if (
        formData.entity &&
        formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase() &&
        formData.products &&
        formData.products.length > 0
      ) {
        // Check if any consumable (non-machine) product has discount > 0
        const hasConsumablesWithDiscount = formData.products.some(
          (product) =>
            product.isMachine === false &&
            parseFloat(product.lineDiscount || 0.00) > 0
        );

        if (hasConsumablesWithDiscount && formData.customerId) {
          console.log(
            `VMCO consumables with discount detected - triggering consumables discount workflow for order ${formData.id}`
          );
          await triggerConsumablesDiscountWorkflow(formData.id, formData.customerId);
        } else {
          console.log("No VMCO consumables with discount > 0 found");
        }
      }

      // After the existing VMCO machines discount workflow trigger, add:

      // Check for VMCO consumables discount workflow
      if (
        formData.entity &&
        formData.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase() &&
        formData.products &&
        formData.products.length > 0 &&
        formData.customerId
      ) {
        // Check if any consumable product has discount > 0
        const consumablesWithDiscount = formData.products.filter(
          (product) =>
            product.isMachine === false &&
            parseFloat(product.lineDiscount || 0.00) > 0
        );

        if (consumablesWithDiscount.length > 0) {
          console.log(
            `Found ${consumablesWithDiscount.length} consumables with discount - triggering consumables discount workflow`
          );
          console.log("Consumables with discount:", consumablesWithDiscount);
          await triggerConsumablesDiscountWorkflow(formData.id, formData.customerId);
        } else {
          console.log("No consumables with line discount > 0 found");
        }
      }


      // STEP 3: Submit the approval for the sales order
      const payload = {
        workflowData: {
          ...(location.state?.workflowData || {}),
          updates,
        },
        approvedStatus: approvalAction === "approve" ? "Approved" : "Rejected",
        comment: comment,
      };

      console.log("Submitting sales order approval with payload:", payload);

      const res = await fetch(`${API_BASE_URL}/workflow-instance/id/${wfid}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        Swal.fire({
          icon: "success",
          title: approvalAction === "approve"
            ? t("Approved Successfully")
            : t("Rejected Successfully"),
          confirmButtonText: t("OK"),
        });
        // alert(t(`${approvalAction.charAt(0).toUpperCase() + approvalAction.slice(1)} successful!`));
        setIsApprovalDialogOpen(false);
        navigate("/orders");
      } else {
        const errorText = await res.text();
        throw new Error(errorText || "Failed to submit approval");
      }
    } catch (error) {
      console.error(`Error ${approvalAction}ing order:`, error);
      Swal.fire({
        icon: "error",
        title: t("Error Submitting Approval"),
        text: t(`Error ${approvalAction}ing order: ${error.message}`),
        confirmButtonText: t("OK"),
      });
      // alert(t(`Error ${approvalAction}ing order: ${error.message}`));
      setIsApprovalDialogOpen(false);
    }
  };

  // Add this handler inside your component, before return
  function handleSelectPaymentMethod(method) {

    setShowPaymentPopup(false);
    setFormData((prev) => {
      // If Cash on Delivery is selected and entity is VMCO, set status to Pending
      if (
        method &&
        method.toLowerCase() === "cash on delivery" &&
        prev.entity &&
        prev.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase()
      ) {
        return { ...prev, paymentMethod: method, status: "Pending" };
      }
      return { ...prev, paymentMethod: method };
    });
    // If a save was pending, continue with save
    if (pendingSaveAction) {
      handleSave(pendingSaveAction, method);
      setPendingSaveAction(null);
    }
  }

  // Debug effect to monitor products loading
  useEffect(() => {
    console.log("formData.products changed:", {
      count: formData.products && formData.products.length ? formData.products.length : 0,
      products: formData.products,
      mode: formMode,
      fromApproval,
      orderId: orderFromNav.id,
    });
  }, [
    formData.products ? formData.products.length : 0,
    formMode,
    fromApproval,
    orderFromNav.id,
  ]);

  const handlePayments = () => {
    navigate(`/payments/${formData?.id}`)
  }
  const handleViewSignature = async (orderId, customerId, Invoices) => {
    setShowModal(true);
    try {
      // Reset PDF files before loading new ones
      setPdfFiles([]); // Optional but recommended to avoid stacking from previous view

      for (let file of Invoices) {
        const { data } = await axios.post(
          `${API_BASE_URL}/get-files`,
          {
            fileName: file,
            containerType: "invoices",
            id: customerId, // replaced hardcoded id:64
            orderId: orderId, // replaced hardcoded orderId:3
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (data?.status === "Ok" && data.data) {
          setPdfFiles((prevFiles) => [...prevFiles, data.data]);
        }
      }
    } catch (error) {
      console.error("Error fetching signature files:", error);
    }
  };
  const handleClose = () => {
    setShowModal(false);
    setPdfFiles([]);
  };
  console.log("formMode111111111", formMode, orderFromNav);
  const getDeliveryFiles = async (erpOrderId) => {
    try {
      const { data } = await axios.post(
        `${API_BASE_URL}/get-delivery-files`,
        {
          containerType: "delivery",
          erpOrderId: erpOrderId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data?.data;
    } catch (error) {
      console.error("Error fetching delivery files:", error);
      throw error;
    }
  };
  useEffect(() => {
    if (formMode === "add") return;

    const fetchImages = async () => {
      if (
        orderFromNav &&
        orderFromNav?.erpOrderId &&
        orderFromNav?.status?.toLowerCase() === "delivered"
      ) {
        try {
          const result = await getDeliveryFiles(orderFromNav?.erpOrderId);
          setDeliveryImages(result || []);
          console.log("Fetched delivery images:", result.data || []);
        } catch (error) {
          console.error("Failed to fetch delivery images:", error);
        }
      }
    };

    fetchImages();
  }, [formMode, orderFromNav]);

  return (
    <Sidebar title={t("Orders")} MenuName={t("Orders")}>
      {isV("orderDetails") && (
        <div>
          <div className="order-details-container">
            <div
              className={`order-details-content ${isCommentPanelOpen ? "collapsed" : ""
                }`}
            >
              <div className="order-details-body">
                <h2 className="order-details-title">
                  {formMode === "add"
                    ? `${t("New Order")}`
                    : `${t("Order #")} ${formData.id}`}
                </h2>
                <h4 style={{ color: "#525b6d" }}> {t("Order Details")}</h4>
                <div className="order-details-section">
                  <div
                    className="order-details-grid "
                    style={{ marginTop: "20px" }}
                  >
                    {isV("customerName") && (
                      <div className="order-details-field">
                        <label htmlFor="customerField">
                          {t("Customer Company Name")}
                        </label>
                        {formMode === "add" ? (
                          <div
                            className="customer-input-container"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                            }}
                          >
                            <input
                              id="customerField"
                              name="selectedCustomerName"
                              readOnly
                              defaultValue={
                                i18n.language === "ar"
                                  ? formData.companyNameAr ||
                                  formData.selectedCustomerName ||
                                  ""
                                  : formData.companyNameEn ||
                                  formData.selectedCustomerName ||
                                  ""
                              }
                              onClick={() => setShowCustomerPopup(true)}
                              className="customer-input"
                              placeholder={t("Click to select customer")}
                              disabled={!isE("customerName")}
                              autoComplete="off"
                            />
                          </div>
                        ) : (
                          <input
                            id="customerField"
                            name="selectedCustomerName"
                            value={
                              i18n.language === "ar"
                                ? formData.companyNameAr ||
                                formData.selectedCustomerName ||
                                ""
                                : formData.companyNameEn ||
                                formData.selectedCustomerName ||
                                ""
                            }
                            disabled={isE("customerName")}
                            readOnly
                          />
                        )}
                      </div>
                    )}
                    {isV("branchName") && (
                      <div className="order-details-field">
                        <label>{t("Branch")}</label>
                        {formMode === "add" ? (
                          <div
                            className="customer-input-container"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                            }}
                          >
                            <input
                              id="branchField"
                              name="selectedBranchName"
                              value={
                                formData.selectedBranchName !== undefined &&
                                  formData.selectedBranchName !== null
                                  ? formData.selectedBranchName
                                  : ""
                              }
                              onClick={() => {
                                if (!formData.selectedCustomerName) {
                                  Swal.fire({
                                    icon: "warning",
                                    title: t("No Customer Selected"),
                                    text: t("Please select a customer first"),
                                    confirmButtonText: t("OK"),
                                  });
                                  return;
                                }
                                if (isE("branchName")) setShowBranchPopup(true);
                              }}
                              className="customer-input"
                              placeholder={t("Click to select branch")}
                              readOnly
                              disabled={!isE("branchName")}
                              autoComplete="off"
                            />
                          </div>
                        ) : (
                          <input
                            id="branchNameField"
                            name="branchName"
                            value={
                              i18n.language === "ar"
                                ? formData.branchNameLc ||
                                formData.selectedBranchName ||
                                ""
                                : formData.branchNameEn ||
                                formData.selectedBranchName ||
                                ""
                            }
                            disabled
                            readOnly
                          />
                        )}
                      </div>
                    )}
                    {isV("orderBy") && (
                      <div className="order-details-field">
                        <label>{t("Order By")}</label>
                        <input
                          name="orderBy"
                          readOnly
                          value={orderFromNav.createdByUsername || ""}
                          onChange={handleInputChange}
                          disabled={!isE("orderBy")}
                        />
                      </div>
                    )}
                    {isV("lastModifiedBy") && (
                      <div className="order-details-field">
                        <label>{t("Last Modified By")}</label>
                        <input
                          name="lastModifiedBy"
                          readOnly
                          value={orderFromNav.modifiedByUsername || ""}
                          disabled={true}
                        />
                      </div>
                    )}
                    {isV("erpOrderId") && (
                      <div className="order-details-field">
                        <label>{t("Sales Order ID")}</label>
                        <input
                          name="erpOrderId"
                          value={
                            formData.erpOrderId !== undefined &&
                              formData.erpOrderId !== null
                              ? formData.erpOrderId
                              : ""
                          }
                          readOnly
                          onChange={handleInputChange}
                          disabled={!isE("erpOrderId")}
                          placeholder={t("ERP#")}
                        />
                      </div>
                    )}
                    {isV("entity") && (
                      <div className="order-details-field">
                        <label>{t("Entity")}</label>
                        {formMode === "add" ? (
                          <select
                            name="entity"
                            value={formData.entity || ""}
                            readOnly
                            onClick={handleEntityChange}
                            onChange={handleInputChange}
                            className="entity-dropdown"
                            disabled={
                              !isE("entity") ||
                              (formData.products &&
                                formData.products.length > 0)
                            }
                          >
                            <option value="">{t("Select Entity")}</option>
                            {entityOptions.map((entity, index) => {
                              // Check if this entity is in the allowed list (case-insensitive)
                              const isEntityAllowed =
                                allowedEntities.length === 0 ||
                                allowedEntities.some(
                                  (allowedEntity) =>
                                    allowedEntity.toLowerCase() ===
                                    entity.toLowerCase()
                                );

                              return (
                                <option
                                  key={index}
                                  value={entity}
                                  readOnly
                                  disabled={!isEntityAllowed}
                                  style={
                                    !isEntityAllowed
                                      ? {
                                        color: "#aaa",
                                        backgroundColor: "#f5f5f5",
                                      }
                                      : {}
                                  }
                                >
                                  {entity}
                                </option>
                              );
                            })}
                          </select>
                        ) : (
                          <input
                            name="entity"
                            value={formData.entity || ""}
                            readOnly
                            disabled
                          />
                        )}
                      </div>
                    )}
                    {isV("category") && (
                      <div className="order-details-field">
                        <label>{t("VMCO / SHC Category")}</label>
                        {formMode === "add" ? (
                          <Dropdown
                            name="category"
                            value={formData.category || ""}
                            readOnly
                            onChange={handleInputChange}
                            options={
                              formData?.entity?.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase()
                                ? VMCO_CATEGORIES.map((category) => ({
                                  value: category,
                                  label: category
                                }))
                                : formData?.entity?.toLowerCase() === Constants.ENTITY.SHC.toLowerCase()
                                  ? SHC_CATEGORIES.map((category) => ({
                                    value: category,
                                    label: category
                                  }))
                                  : []
                            }
                            className="category-dropdown"
                            placeholder={t("Applicable for VMCO or SHC")}
                            disabled={
                              !isE("category") ||
                              (formData.products && formData.products.length > 0) ||
                              !formData.entity ||
                              (formData.entity.toLowerCase() !== Constants.ENTITY.VMCO.toLowerCase() &&
                                formData.entity.toLowerCase() !== Constants.ENTITY.SHC.toLowerCase())
                            }
                          />
                        ) : (
                          <input
                            name="category"
                            value={formData.category || ""}
                            readOnly
                            disabled
                          />
                        )}
                      </div>
                    )}
                    {isV("paymentMethod") && (
                      <div className="order-details-field">
                        <label>{t("Payment Method")}</label>
                        <input
                          name="paymentMethod"
                          value={
                            sampleMode || formData.sampleOrder
                              ? t("FOC") : t(formData.paymentMethod?.toLowerCase() === "pre payment" ? "Card Payment" : formData.paymentMethod)
                          }
                          disabled
                        />
                      </div>
                    )}
                    {isV("totalAmount") && (
                      <div className="order-details-field">
                        <label>{t("Total Amount")}</label>
                        <input
                          name="totalAmount"
                          value={roundTo2(formData.totalAmount)}
                          disabled
                          readOnly
                        />
                      </div>
                    )}{" "}
                    {isV("paymentPercentage", fromApproval, true) &&
                      fromApproval && (
                        <div className="order-details-field">
                          <label>{t("Payment Percentage")}</label>
                          <select
                            name="paymentPercentage"
                            value={formData.paymentPercentage || "100%"} // ✅ Always defaults to 100%
                            onChange={handleInputChange}
                            disabled={
                              !fromApproval &&
                              formData.category !== Constants.CATEGORY.VMCO_MACHINES
                            }
                          >
                            <option value="100%">100%</option>
                            <option value="30%">30%</option>
                          </select>
                        </div>
                      )}
                    {isV("paidAmount") && (
                      <div className="order-details-field">
                        <label>{t("Amount Paid")}</label>
                        <input
                          name="paidAmount"
                          value={
                            Math.floor(formData.paidAmount * 100) / 100
                              ? Math.floor(formData.paidAmount * 100) / 100
                              : 0.0
                          }
                          onChange={handleInputChange}
                          disabled={!isE("paidAmount")}
                        />
                      </div>
                    )}
                    {isV("deliveryCharges") && (
                      <div className="order-details-field">
                        <label>{t("Delivery Charge with VAT")}</label>
                        {formMode === "add" ? (
                          <input
                            type="text"
                            name="deliveryCharges"
                            value={t("Will be automatically updated")}
                            disabled
                            readOnly
                            style={{
                              background: "#f9f9f9",
                              color: "#999",
                              cursor: "not-allowed",
                            }}
                          />
                        ) : (
                          <input
                            type="number"
                            name="deliveryCharges"
                            value={Math.floor((formData.deliveryCharges ?? 0) * 100) / 100}
                            onChange={handleInputChange}
                            disabled={!isE("deliveryCharges")}
                            placeholder={t("Delivery Charges")}
                            step="0.01"
                          />
                        )}
                      </div>
                    )}

                    {isV("expectedDeliveryDate") && (
                      <div className="order-details-field">
                        <label>{t("Delivery Date")}</label>
                        {formMode === "add" ? (
                          <input
                            type="text"
                            name="expectedDeliveryDate"
                            value={t("Delivery Date will be updated later")}
                            disabled
                            readOnly
                            style={{
                              background: "#f9f9f9",
                              color: "#999",
                              cursor: "not-allowed",
                            }}
                          />
                        ) : fromApproval ? (
                          <input
                            name="expectedDeliveryDate"
                            value={
                              formData.expectedDeliveryDate
                                ? convertToTimezone(
                                  formData.expectedDeliveryDate,
                                  TIMEZONES.SAUDI_ARABIA,
                                  "DD/MM/YYYY"
                                )
                                : "Delivery date will update soon"
                            }
                            disabled
                            readOnly
                            style={{
                              background: "#f9f9f9",
                              color: formData.expectedDeliveryDate
                                ? "#000"
                                : "#999",
                            }}
                          />
                        ) : formData.expectedDeliveryDate ? (
                          <input
                            name="expectedDeliveryDate"
                            value={convertToTimezone(
                              formData.expectedDeliveryDate,
                              TIMEZONES.SAUDI_ARABIA,
                              "YYYY-MM-DD"
                            )}
                            onChange={handleInputChange}
                            disabled={!isE("expectedDeliveryDate")}
                          />
                        ) : (
                          <input
                            name="expectedDeliveryDate"
                            value={t("Delivery date will update soon")}
                            disabled
                            readOnly
                            style={{
                              background: "#f9f9f9",
                              color: "#999",
                              cursor: "not-allowed",
                            }}
                          />
                        )}
                      </div>
                    )}
                    {isV("pricingPolicy", fromApproval, true) &&
                      fromApproval && (
                        <div className="order-details-field">
                          <label>{t("Pricing Policy")}</label>
                          <select
                            name="pricingPolicy"
                            value={formData.pricingPolicy || ''}
                            onChange={handleInputChange}
                            disabled={!isE('pricingPolicy')}
                          >
                            <option value="">{t(formData.pricingPolicy)}</option>
                            {i18n.language === 'ar'
                              ? pricingPolicyArOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))
                              : pricingPolicyEnOptions.map(option => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))
                            }
                          </select>
                        </div>
                      )}
                    {isV("warehouse") &&
                      formMode === "edit" && (
                        <div className="order-details-field">
                          <label>{t("Warehouse")} *</label>
                          {isMobile ? (
                            <select
                              name="warehouse"
                              value={selectedWarehouse || ""}
                              onChange={
                                handleWarehouseChange
                              }
                              className="entity-dropdown"
                              disabled={!isE("warehouse") || warehousesLoading || formData.status.toLowerCase() === "approved" || !fromApproval}
                            // placeholder={selectedWarehouse ? selectedWarehouse : t("Select Warehouse")}
                            >
                              <option value="" disabled hidden>
                                {t("Select Warehouse")}
                              </option>
                              {warehouseOptions.map(
                                (warehouse, index) => (
                                  <option key={index} value={warehouse?.name}>
                                    {i18n.language === "en" ? warehouse?.warehouseNameEn : warehouse?.warehouseNameAr}
                                  </option>
                                )
                              )}
                            </select>
                          ) : (
                            <SearchableDropdown
                              options={warehouseOptions}
                              value={selectedWarehouse || ""}
                              onChange={handleWarehouseChange}
                              disabled={!isE("warehouse") || warehousesLoading || formData.status.toLowerCase() === "approved" || !fromApproval}
                              placeholder={selectedWarehouse ? selectedWarehouse : t("Select Warehouse")}
                              className="entity-dropdown"
                            />
                          )}
                          {warehousesLoading && <div className="loading-indicator">Loading...</div>}
                        </div>
                      )
                    }

                    {/* Reservation Status field - visible only in edit mode for VMCO entity with machines */}
                    {isV("reservationStatus") &&
                      isEditMode &&
                      formData.entity &&
                      formData.entity.toLowerCase() ===
                      Constants.ENTITY.VMCO.toLowerCase() &&
                      (formData.isMachine === true ||
                        (formData.products &&
                          formData.products.length > 0 &&
                          formData.products.some(
                            (product) => product.isMachine === true
                          ))) &&
                      (user?.roles?.[0] === Constants.ROLES.CUSTOMER_PRIMARY ||
                        user?.roles?.[0] === Constants.ROLES.BRANCH_PRIMARY ||
                        (user?.userType === "employee" &&
                          user?.designation ===
                          Constants.DESIGNATIONS.SALES_EXECUTIVE) ||
                        user?.roles?.[0] === Constants.ROLES.SUPER_ADMIN) && (
                        <div className="order-details-field">
                          <label>{t("Reservation Status")}</label>
                          <input
                            name="reservationStatus"
                            value={
                              formData.reserved === true
                                ? t("Reserved")
                                : t("Unreserved")
                            }
                            disabled={!isE("reservationStatus")}
                            style={
                              !isE("reservationStatus")
                                ? {
                                  background: "#f9f9f9",
                                  color: "#999",
                                  cursor: "not-allowed",
                                }
                                : {}
                            }
                            readOnly
                          />
                        </div>
                      )}

                    {isV("createdDate") && (
                      <div className="order-details-field">
                        <label>{t("Order Placement Date")}</label>
                        <input
                          name="createdDate"
                          value={
                            formData.createdAt
                              ? convertToTimezone(
                                formData.createdAt,
                                TIMEZONES.SAUDI_ARABIA,
                                "DD/MM/YYYY HH:MM"
                              )
                              : ""
                          }
                          disabled
                        />
                      </div>
                    )}
                    {isV("updatedDate") && (
                      <div className="order-details-field">
                        <label>{t("Updated Date")}</label>
                        <input
                          name="updatedDate"
                          value={
                            formData.updatedAt
                              ? convertToTimezone(
                                formData.updatedAt,
                                TIMEZONES.SAUDI_ARABIA,
                                "DD/MM/YYYY HH:MM"
                              )
                              : ""
                          }
                          disabled
                        />
                      </div>
                    )}
                    {isV("driver") && (
                      <div className="order-details-field">
                        <label>{t("Driver")}</label>
                        <input
                          name="driver"
                          value={formData.driver ?? ""}
                          onChange={handleInputChange}
                          disabled={!isE("driver")}
                        />
                      </div>
                    )}
                    {isV("vehicleNumber") && (
                      <div className="order-details-field">
                        <label>{t("Vehicle Number")}</label>
                        <input
                          name="vehicleNumber"
                          value={formData.vehicleNumber ?? ""}
                          onChange={handleInputChange}
                          disabled={!isE("vehicleNumber")}
                        />
                      </div>
                    )}
                    {formData?.poNumber && (<div className="order-details-field">
                      <label>{t("PO Number")}</label>
                      <input
                        name="poNumber"
                        value={formData?.poNumber}
                        disabled={true}
                      />
                    </div>)}
                  </div>

                  {formData?.note && (<div className="order-details-field">
                    <label>{t("Note")}</label>
                    <textarea

                      value={formData?.note}
                      disabled={true}
                    /></div>)}
                  {isV("images") &&formData?.status?.toLowerCase() === "delivered"&& (
                    <>
                      <label>{t("Delivery images")}</label>
                      <div className="maintenance-images-list">
                        {/* {isV('addImages') && (
                          <>
                            <button
                              type="button"
                              className="maintenance-add-image-btn"
                              onClick={openFileDialog}
                              title="Add Image"
                              disabled={!isE('vehicleNumber')}
                            >
                              +
                            </button>
                            <input
                              type="file"
                              accept="image/*"
                              ref={fileInputRef}
                              style={{ display: 'none' }}
                              onChange={handleAddImage}
                            />
                          </>
                        )} */}
                        {deliveryImages?.map((img, idx) => {
                          const fileUrl = img.url;
                          const fileName =
                            img.filename || img.fileName || `file-${idx}`;
                          const extension = fileName
                            .split(".")
                            .pop()
                            .toLowerCase();

                          const isImage = [
                            "png",
                            "jpg",
                            "jpeg",
                            "gif",
                            "webp",
                          ].includes(extension);
                          const isPdf = extension === "pdf";
                          const isExcel = ["xls", "xlsx", "csv"].includes(
                            extension
                          );

                          return (
                            <div
                              key={idx}
                              className="maintenance-image-placeholder"
                              style={
                                isImage && fileUrl
                                  ? {
                                    backgroundImage: `url(${fileUrl})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                  }
                                  : {}
                              }
                              onClick={() =>
                                isImage && fileUrl && setPopupImage(fileUrl)
                              }
                              title={isImage && fileUrl ? "Click to view" : ""}
                            >
                              {!isImage && fileUrl && (
                                <a
                                  href={fileUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="file-link-button"
                                >
                                  {isPdf
                                    ? "📄 View PDF"
                                    : isExcel
                                      ? "📊 Open Excel"
                                      : "📁 Download File"}
                                </a>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>

                {/* Products Section with DataGrid */}
                {isV("products") && (
                  <>
                    <h3 className="order-details-subtitle">{t("Products")}</h3>
                    {(formMode === "add" ||
                      (formMode === "edit" && isE("products"))) && (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            marginBottom: 8,
                          }}
                        >
                          {isV("addProducts") && (
                            <button
                              type="button"
                              className="order-action-btn approve"
                              onClick={() => {
                                // In add mode, require customer, branch, and entity selection
                                if (formMode === "add") {
                                  if (!formData.selectedCustomerName) {
                                    Swal.fire({
                                      title: t("Select Customer"),
                                      text: t("Please select a customer first"),
                                      icon: "warning",
                                      confirmButtonText: t("OK"),
                                    });
                                    return;
                                  } else if (!formData.selectedBranchName) {
                                    Swal.fire({
                                      title: t("Select Branch"),
                                      text: t("Please select a branch first"),
                                      icon: "warning",
                                      confirmButtonText: t("OK"),
                                    });
                                    return;
                                  } else if (!formData.entity) {
                                    Swal.fire({
                                      title: t("Select Entity"),
                                      text: t("Please select an entity first"),
                                      icon: "warning",
                                      confirmButtonText: t("OK"),
                                    });
                                    return;
                                  } else if (['vmco', 'shc'].includes(formData?.entity?.toLowerCase()) && !formData?.category) {
                                    Swal.fire({
                                      title: t("VMCO / SHC Category"),
                                      text: t("Please select an Category first"),
                                      icon: "warning",
                                      confirmButtonText: t("OK"),
                                    });
                                    return;
                                  }
                                }
                                setShowProductPopup(true);
                              }}
                              disabled={!isE("addProducts") || (formMode === "edit" && !fromApproval && orderFromNav.status.toLowerCase() !== "open")}
                              style={{
                                cursor: !isE("addProducts") ? "not-allowed" : "pointer",
                              }}
                            >
                              {t("Add products")}
                            </button>
                          )}
                          {isV("sampleOrder", fromApproval, true) && (
                            isMobile ? (
                              <div
                                className="order-action-btn sample-switch-container"
                                style={{
                                  position: 'relative',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-around',
                                  padding: '4px 6px',
                                  height: '100%',
                                  border: 'none',
                                  transition: 'none',
                                  pointerEvents: 'none'
                                }}
                              >
                                <div style={{ pointerEvents: 'auto' }}>  {/* Make only switch clickable */}
                                  <Switch
                                    checked={sampleMode || formData.sampleOrder}
                                    onClick={() => setSampleMode(!sampleMode)}
                                    disabled={
                                      !isE("sampleOrder") ||
                                      (formData.products && formData.products.length > 0)
                                    }
                                    sx={{
                                      width: 44,
                                      height: 26,
                                      padding: 0,
                                      '& .MuiSwitch-switchBase': {
                                        padding: '2px',
                                        margin: '0',
                                      },
                                      '& .MuiSwitch-switchBase.Mui-checked': {
                                        color: 'white',
                                      },
                                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                        backgroundColor: 'var(--logo-orange)',
                                      },
                                      '& .Mui-disabled': {
                                        opacity: 0.4,
                                      },
                                      '& .MuiSwitch-track': {
                                        borderRadius: 13,
                                        backgroundColor: '#d9d9d6',
                                        height: 22,
                                      },
                                      '& .MuiSwitch-thumb': {
                                        width: 18,
                                        height: 18,
                                        boxShadow: '0px 2px 4px rgba(0,0,0,0.2)',
                                        zIndex: 1,
                                      },
                                      '& .MuiSwitch-switchBase.Mui-disabled .MuiSwitch-thumb': {
                                        color: '#a0a0a0',
                                      },
                                      // Disable all hover effects
                                      '&:hover': {
                                        backgroundColor: 'transparent',
                                      },
                                      '& .MuiSwitch-switchBase:hover': {
                                        backgroundColor: 'transparent',
                                      },
                                      'css-aqlqb4-MuiButtonBase-root-MuiSwitchBase-root-MuiSwitch-switchBase .MuiSwitch-input': {
                                        left: '0',
                                        width: '100%',
                                      },
                                      '.css-aqlqb4-MuiButtonBase-root-MuiSwitchBase-root-MuiSwitch-switchBase.Mui-checked:hover': {
                                        backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                        padding: '2px',
                                      },
                                    }}
                                  />
                                </div>
                                <span style={{
                                  fontWeight: 600,
                                  fontSize: '12px',
                                  color: (!isE("sampleOrder") || (formData.products && formData.products.length > 0)) ? '#a0a0a0' : '#222',
                                }}>
                                  {t("Sample Order")}
                                </span>
                              </div>
                            ) : (
                              <button
                                type="button"
                                className="order-action-btn"
                                onClick={() => setSampleMode(!sampleMode)}
                                disabled={
                                  !isE("sampleOrder") ||
                                  (formData.products && formData.products.length > 0)
                                }
                                style={{
                                  backgroundColor: sampleMode || formData.sampleOrder ? "var(--logo-orange)" : "white",
                                  color: "black",
                                  border: "1px solid #ccc",
                                  cursor:
                                    !isE("sampleOrder") ||
                                      (formData.products && formData.products.length > 0)
                                      ? "not-allowed"
                                      : "pointer",
                                }}
                              >
                                {t("Sample Order")}
                              </button>
                            )
                          )}
                        </div>
                      )}

                    {!isMobile ?
                      (formMode !== "add" ||
                        (formData.products || []).length > 0) && (
                        <div
                          className="order-products-section"
                          style={{
                            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                            padding: "16px",
                            borderRadius: "8px",
                          }}
                        >
                          <DataGrid
                            apiRef={gridApiRef}
                            rows={(formData.products || []).filter(
                              (p) =>
                                p.id ||
                                p.erp_prodd ||
                                p.quantity ||
                                p.unit ||
                                p.unitPrice ||
                                p.lineDiscount ||
                                p.netAmount ||
                                p.vatPercentage
                            )}
                            columns={visibleProductColumns}
                            disableSelectionOnClick
                            disableColumnMenu
                            disableColumnSorting
                            hideFooter={true}
                            hideFooterPagination={true}
                            disableExtendRowFullWidth={true}
                            pagination={false}
                            autoHeight
                            rowHeight={55}
                            getRowId={(row) => row.id || row.productId}
                            sx={{
                              "& .MuiDataGrid-cell": {
                                display: "flex",
                                alignItems: "center",
                              },
                              "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#f5f5f5",
                                fontWeight: "bold",
                              },
                              "& .MuiDataGrid-row:hover": {
                                backgroundColor: "rgba(0, 0, 0, 0.04)",
                              },
                            }}
                          />
                        </div>
                      )
                      :
                      (formMode !== "add" || (formData.products || []).length > 0) && (
                        <div
                          className="order-products-section"
                          style={{
                            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                            padding: "16px",
                            borderRadius: "8px",
                            background: "#fff",
                          }}
                        >
                          {(formData.products || []).filter(
                            (p) =>
                              p.id ||
                              p.erpProdId ||
                              p.quantity ||
                              p.unit ||
                              p.unitPrice ||
                              p.lineDiscount ||
                              p.netAmount ||
                              p.vatPercentage
                          ).length > 0 ? (
                            <div className="product-list">
                              {(formData.products || []).map((item, idx) => (

                                <>
                                  <div key={item.id || idx} className="cart-item">
                                    {/* Product Image */}
                                    <div className="item-image" style={{ flexDirection: "row", justifyContent: "left" }}>
                                      <img
                                        src={item.imageUrl
                                          // || `${APP_BLOB_URL}/vmco-products/${item.erpProdId}/default.jpg`
                                        }
                                        alt={item.name}
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          // e.target.src = `${APP_BLOB_URL}/vmco-products/${item.erpProdId}/default.jpg`;
                                        }}
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          objectFit: "contain",
                                          borderRadius: 8,
                                        }}
                                      />
                                    </div>

                                    {/* Product Details */}
                                    <div className="item-details" style={{ gap: 0, marginTop: 0 }}>
                                      <h4 className="item-name">{i18n.language === "ar" ? item.productNameLc : item.productName || t("Unnamed Product")}</h4>
                                      <p className="item-code">{item.productCode}</p>
                                      {item.description && (
                                        <p className="item-description">{item.description}</p>
                                      )}

                                      <div className="product-meta">
                                        <p>
                                          {t("Unit Price: ")}
                                          <span style={{ fontWeight: "460" }}>
                                            {Math.floor((item.unitPrice || item.price || 0) * 100) / 100}{" "}
                                            {t("SAR")}
                                          </span>
                                        </p>
                                        <p style={{ marginBottom: "12px" }}>
                                          {t("Quantity")}: <span style={{ fontWeight: "460" }}>{item.quantity || 0}</span>
                                        </p>
                                        <div
                                          className="quantity-controller"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                          }}
                                        >
                                          <QuantityController
                                            itemId={item.id || item.productid}
                                            quantity={item.quantity}
                                            moq={Number(item.moq) || 1}
                                            minQuantity={Number(item.moq) || 1}
                                            disabled={!isE("quantityCol")}
                                            onQuantityChange={(itemId, delta) => {
                                              if (!isE("quantityCol")) return;

                                              const idx = (formData.products || []).findIndex(
                                                (p) => p.id === item.id
                                              );

                                              if (idx !== -1) {
                                                const currentQty = parseInt(formData.products[idx].quantity) || 0;
                                                const newQty = Math.max(0, currentQty + delta);
                                                handleQuantityChange(idx, newQty);
                                              }
                                            }}
                                            onInputChange={(itemId, value) => {
                                              if (!isE("products")) return;

                                              const idx = (formData.products || []).findIndex(
                                                (p) => p.id === item.id
                                              );

                                              if (idx !== -1) {
                                                handleQuantityChange(idx, value === "" ? "" : value);
                                              }
                                            }}
                                          />

                                          {/* Stock button for VMCO entity */}
                                          {isV("stock") &&
                                            formData.entity &&
                                            formData.entity.toLowerCase() ===
                                            Constants.ENTITY.VMCO.toLowerCase() && (
                                              <span>
                                                <button
                                                  type="button"
                                                  style={{
                                                    background: "#e6f2ef",
                                                    color: "#0a5640",
                                                    border: "1px solid #0a5640",
                                                    borderRadius: "4px",
                                                    fontSize: "12px",
                                                    padding: "2px 8px",
                                                    marginLeft: "6px",
                                                    marginRight: "6px",
                                                    cursor: "pointer",
                                                  }}
                                                  title={item.unit ? `Stock for ${item.unit}` : "Stock"}
                                                  onClick={() =>
                                                    handleStock(
                                                      item.id,
                                                      i18n.language === "ar"
                                                        ? item.productNameLc ||
                                                        item.productnamelc ||
                                                        item.productName
                                                        : item.productName ||
                                                        item.productnameen ||
                                                        item.productNameLc
                                                    )
                                                  }
                                                >
                                                  {t("Stock")}
                                                </button>
                                              </span>
                                            )}

                                          {InventoryLoading && loadingProductId === item.id && <LoadingSpinner />}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div style={{ marginBottom: 10 }}>
                                   <h4 className="item-name" style={{fontSize:"small"}}>{i18n.language === "ar" ? item.productNameLc : item.productName || t("Unnamed Product")}</h4>
                                  </div> */}
                                  {/* Price Summary */}
                                  <div className="item-price-panel-with-delete" style={{ display: "flex", flexDirection: "row", marginBottom: "10px", justifyContent: "space-around" }} >
                                    <div className="item-price-panel" >
                                      <span className="tax-row" style={{ fontSize: 13 }} >
                                        {t("VAT: ")}
                                        {Number(item.vatPercentage)}%
                                      </span>
                                      {formData.entity.toLocaleLowerCase() === Constants.ENTITY.VMCO.toLocaleLowerCase() &&
                                        <span className="line-discount-row" style={{ fontSize: 13 }} >
                                          {t("Discount: ")}

                                          {fromApproval ? (<>
                                            <input
                                              type="number"
                                              min="0"
                                              max="100"
                                              step="0.01"
                                              value={editingDiscount[item.id] !== undefined
                                                ? editingDiscount[item.id]
                                                : item?.lineDiscount}
                                              onChange={(e) => {
                                                const idx = formData.products.findIndex(
                                                  (p) => (p.id || p.productid) === (item.id || item.productid)
                                                );
                                                setEditingDiscount((prev) => ({
                                                  ...prev,
                                                  [item.id]: e.target.value,
                                                }));
                                                handleLineDiscountChange(idx, parseFloat(e.target.value))
                                              }
                                              }
                                              style={{
                                                width: 40,
                                                fontSize: 13,
                                                borderRadius: 4,
                                                marginRight: 4,
                                                border: "1px solid black",
                                                textAlign: "center"
                                              }}
                                            />

                                            %
                                          </>) : <>
                                            {Number(item.lineDiscount)}%
                                          </>}
                                        </span>}
                                      {/* {formData.entity?.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase() && (
  <span className="line-discount-row" style={{ fontSize: 13 }}>
    <>
    {t("Discount:")}
    <input
      type="number"
      min="0"
      max="100"
      step="0.01"
      value={item.lineDiscount ?? ""}
      onChange={(e) =>
        handleLineDiscountChange(item.id, e.target.value)
      }
      style={{
        width: 60,
        fontSize: 13,
        marginRight: 4,
      }}
    />

    %
    </>
  </span>
)} */}

                                      <span className="item-total-price" style={{ fontSize: 13 }}>
                                        {t("Net Amount:")}{" "}
                                        {(
                                          roundTo2(item.unitPrice || item.price || 0 * 100) / 100 *
                                          roundTo2(item.quantity || 1) +
                                          ((Math.floor(item.unitPrice || item.price || 0 * 100) / 100 *
                                            Math.floor(item.quantity || 1) *
                                            Math.floor(item.vatPercentage * 100) / 100) /
                                            100)
                                        )}{" "}
                                        {t("SAR")}
                                      </span>
                                    </div>
                                    {isV("deleteButton") &&
                                      isE("deleteCol") && (
                                        <button
                                          className="order-action-btn reject"
                                          style={{ marginTop: "20px", ...(i18n.language === "ar" ? { marginRight: "40px" } : { marginLeft: "40px" }), fontSize: 12, width: "90px", justifyContent: "flex-end" }}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleDeleteProductRow(idx);
                                          }}
                                          type="button"
                                          disabled={
                                            !isE("deleteButton") ||
                                            (formData.status &&
                                              !["open"].includes(formData.status.toLowerCase()))
                                          }
                                        >
                                          {t("Delete")}
                                        </button>)}
                                  </div>
                                  <div style={{ borderBottom: "1.5px solid #ccc", marginBottom: 10 }}></div>
                                </>
                              ))}
                            </div>
                          ) : (
                            <p className="no-data">{t("No products available")}</p>
                          )}
                        </div>
                      )}

                  </>
                )}

              </div>
            </div>

            {/* Comment Panel Popup */}
            <div>
              <OrderDetailsCommentPopup
                isOpen={isCommentPanelOpen}
                setIsOpen={setIsCommentPanelOpen}
                onAddComment={(commentText, newComment) => {
                  const existingComments = formData.comments
                    ? (typeof formData.comments === 'string'
                      ? JSON.parse(formData.comments)
                      : formData.comments)
                    : [];

                  const updatedComments = [newComment, ...existingComments];

                  setFormData(prev => ({
                    ...prev,
                    comments: JSON.stringify(updatedComments)
                  }));
                  const token = localStorage.getItem("token");
                  const saveComment = async () => {
                    try {
                      const response = await fetch(`${API_BASE_URL}/sales-order/id/${formData.id}`, {
                        method: 'PATCH',
                        headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                          comments: JSON.stringify(updatedComments)
                        }),
                      });

                      if (!response.ok) {
                        throw new Error('Failed to save comment');
                      }
                    } catch (error) {
                      setFormData(prev => ({
                        ...prev,
                        comments: formData.comments
                      }));

                      Swal.fire({
                        icon: 'error',
                        title: t('Error'),
                        text: t('Failed to save comment'),
                        confirmButtonText: t("OK")
                      });
                    }
                  };

                  saveComment();
                }}
                showCommentForm={true}
                currentUser={user}
                isVisible={true}
                formData={formData}
                approvalHistory={approvalHistory}
              />
            </div>
            <GetInventory
              open={showInventory}
              onClose={() => setShowInventory(false)}
              InventoryData={InventoryData}
              productName={productName}
            />
            <Remarks open={showRemarks} onClose={() => setShowRemarks(false)} />
            {/* Product Popup */}
            {showProductPopup && (
              <GetProducts
                open={showProductPopup}
                onClose={() => setShowProductPopup(false)}
                onSelectProduct={handleSelectProduct}
                API_BASE_URL={API_BASE_URL}
                token={localStorage.getItem("token")}
                customerId={formData.customerId}
                entity={formData.entity}
                category={formData.category}
                t={t}
              />
            )}

            {/* Customer Popup */}
            {showCustomerPopup && (
              <GetCustomers
                open={showCustomerPopup}
                onClose={() => setShowCustomerPopup(false)}
                onSelectCustomer={handleSelectCustomer}
                API_BASE_URL={API_BASE_URL}
                t={t}
                apiEndpoint="/customers/pagination"
                apiParams={{
                  page: 1,
                  pageSize: isMobile ? 5 : 10,
                  sortBy: "id",
                  sortOrder: "asc",
                  purpose: "order creation",
                }}
              />
            )}

            {/* Branch Popup */}
            {showBranchPopup && (
              <GetBranches
                open={showBranchPopup}
                onClose={() => setShowBranchPopup(false)}
                onSelectBranch={handleSelectBranch}
                customerId={formData.customerId}
                API_BASE_URL={API_BASE_URL}
                t={t}
              />
            )}

            {/* Image Popup */}
            {popupImage && (
              <div
                className="image-popup-overlay"
                onClick={() => setPopupImage(null)}
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: "rgba(0,0,0,0.7)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 1000,
                }}
              >
                <img
                  src={popupImage}
                  alt="Preview"
                  style={{
                    maxHeight: "80vh",
                    maxWidth: "90vw",
                    borderRadius: 8,
                    background: "#fff",
                  }}
                  onClick={(e) => e.stopPropagation()}
                />
                <button
                  onClick={() => setPopupImage(null)}
                  style={{
                    position: "absolute",
                    top: 20,
                    right: 40,
                    fontSize: 24,
                    background: "transparent",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                  }}
                  aria-label={t("Close")}
                >
                  &times;
                </button>
              </div>
            )}

            <ApprovalDialog
              isOpen={isApprovalDialogOpen}
              onClose={() => setIsApprovalDialogOpen(false)}
              action={approvalAction}
              onSubmit={handleDialogSubmit}
              customerName={
                formData.selectedCustomerName ||
                formData.companyNameEn ||
                "this order"
              }
              title={
                approvalAction === "approve"
                  ? t("Approve Order")
                  : t("Reject Order")
              }
              subtitle={
                approvalAction === "approve"
                  ? t("Are you sure you want to approve this order?")
                  : t("Are you sure you want to reject this order?")
              }
            />

            {/* Payment Method Popup */}
            <GetPaymentMethods
              open={showPaymentPopup}
              onClose={() => setShowPaymentPopup(false)}
              onSelectPaymentMethod={handleSelectPaymentMethod}
              API_BASE_URL={API_BASE_URL}
              t={t}
            />
          </div>
          {isV("orderFooter") && (
            <div className="order-details-footer">

              {isV("orderStatus") && (
                <div className="order-status">
                  <span className="status-label">{t("Status")}:</span>
                  <span
                    className={`status-badge status-${formData.status?.toLowerCase() || "open"
                      }`}
                  >
                    {t(formData.status) || t("Open")}
                  </span>
                </div>
              )}
              <div className="" style={{ display: "flex", gap: "10px", alignItems: 'center', 'justifySelf': 'start', width: isMobile ? '100%' : 'auto' }}>
                {(isV("paymentLines")) && formData?.paymentStatus?.toLowerCase() === "paid" && formData?.paymentMethod?.toLowerCase() == "pre payment" && formData?.sample_order !== true && (
                  <button
                    className="order-action-btn"
                    onClick={() => handlePayments("save")}
                    disabled={!isE("paymentLines")

                    }
                  >
                    {t('Payments')}
                  </button>
                )}
                {isV("btnSave", fromApproval, false) && isE("btnSave") && (
                  <button
                    className="order-action-btn"
                    onClick={() => handleSave("save")}
                    disabled={isProcessingRef.current || saving || (formData.status && !["open"].includes(formData.status.toLowerCase()))}
                  >
                    {saving ? t("Saving...") : t("Save")}
                  </button>
                )}

                {isV('btnCancel', fromApproval, false) && isE('btnCancel') && (
                  <button
                    className="order-action-btn reject"
                    onClick={handleCancelOrderClick} // Changed from handleCancelOrder
                    disabled={
                      cancelling ||
                      !['open'].includes(formData.status?.toLowerCase()) ||
                      ['paid', 'under review'].includes(formData.paymentStatus?.toLowerCase())
                    }
                  >
                    {cancelling ? t('Cancelling...') : t('Cancel Order')}
                  </button>
                )}

                {isV("btnInvoice", fromApproval, false) &&
                  isE("btnInvoice") &&
                  ["invoiced", "delivered"].includes(
                    formData?.status?.toLowerCase()
                  ) && (
                    <button
                      className="order-action-btn"
                      onClick={() =>
                        handleViewSignature(
                          formData.id,
                          formData.customerId,
                          formData.invoices
                        )
                      }
                    >
                      {t("Invoice")}
                    </button>
                  )}

                {isV("btnInventory") && isE("btnInventory") && (
                  <button
                    className="order-action-btn"
                    onClick={() => setShowInventory(true)}
                  >
                    {t("Get Inventory")}
                  </button>
                )}

                {(isV("btnPay") &&
                  isE("btnPay") &&
                  formData?.status?.toLowerCase() !== "cancelled" && formData?.status?.toLowerCase() !== "rejected" &&
                  formData?.paymentMethod?.toLowerCase() != "cash on delivery" &&
                  formData?.paymentMethod?.toLowerCase() !== "credit" &&
                  (!(formData?.paymentStatus?.toLowerCase() == "paid" || formData?.paymentStatus?.toLowerCase() == "under review")) &&
                  (
                    (formData?.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase() &&
                      formData?.status?.toLowerCase() === "approved") ||
                    (
                      formData?.status?.toLowerCase() === "open" &&
                      (
                        formData?.entity.toLowerCase() === Constants.ENTITY.DAR.toLowerCase() ||
                        formData?.entity.toLowerCase() === Constants.ENTITY.GMTC.toLowerCase() ||
                        formData?.entity.toLowerCase() === Constants.ENTITY.SHC.toLowerCase()
                      )
                    ) ||
                    (formData?.status?.toLowerCase() === "pending" &&
                      (
                        formData?.entity.toLowerCase() === Constants.ENTITY.DAR.toLowerCase() ||
                        formData?.entity.toLowerCase() === Constants.ENTITY.GMTC.toLowerCase() ||
                        formData?.entity.toLowerCase() === Constants.ENTITY.SHC.toLowerCase() ||
                        formData?.entity.toLowerCase() === Constants.ENTITY.NAQI.toLowerCase()
                      )
                    )
                  ) && (
                    <button
                      className="order-action-btn"
                      onClick={() => handleCheckout(orderId)}
                      style={{
                        width: "160px",
                        backgroundColor: "#005932",
                        color: "white",
                      }}
                    >
                      {t("Pay")}
                    </button>
                  ))}
                {(isV("btnSendLink") &&
                  isE("btnSendLink") &&
                  formData?.status?.toLowerCase() !== "cancelled" && formData?.status?.toLowerCase() !== "rejected" &&
                  formData?.paymentMethod?.toLowerCase() != "cash on delivery" &&
                  formData?.paymentMethod?.toLowerCase() !== "credit" &&
                  formData?.paymentStatus?.toLowerCase() !== "paid" &&
                  (
                    (formData?.entity.toLowerCase() === Constants.ENTITY.VMCO.toLowerCase() &&
                      formData?.status?.toLowerCase() === "approved") ||
                    (
                      formData?.status?.toLowerCase() === "open" &&
                      (
                        formData?.entity.toLowerCase() === Constants.ENTITY.DAR.toLowerCase() ||
                        formData?.entity.toLowerCase() === Constants.ENTITY.GMTC.toLowerCase() ||
                        formData?.entity.toLowerCase() === Constants.ENTITY.SHC.toLowerCase()
                      )
                    ) ||
                    (formData?.status?.toLowerCase() === "pending" &&
                      (
                        formData?.entity.toLowerCase() === Constants.ENTITY.DAR.toLowerCase() ||
                        formData?.entity.toLowerCase() === Constants.ENTITY.GMTC.toLowerCase() ||
                        formData?.entity.toLowerCase() === Constants.ENTITY.SHC.toLowerCase() ||
                        formData?.entity.toLowerCase() === Constants.ENTITY.NAQI.toLowerCase()
                      )
                    )
                  ) && (
                    <button
                      className="order-action-btn"
                      onClick={() => handleCheckout(orderId, false, true)}
                      style={{
                        //width: "160px",
                        backgroundColor: "#005932",
                        color: "white",
                      }}
                    >
                      {t("Send Link")}
                    </button>
                  ))}

                {isV("actionButtons") && fromApproval && (
                  <div className="order-details-actions">
                    {isV("btnApprove", fromApproval, true) && (
                      <button
                        className="order-action-btn approve"
                        onClick={() => handleApprovalSubmit("approve")}
                        disabled={formData.status === "approved"}
                      >
                        {t("Approve")}
                      </button>
                    )}

                    {isV("btnReject", fromApproval, true) && (
                      <button
                        className="order-action-btn reject"
                        onClick={() => handleApprovalSubmit("reject")}
                        disabled={formData.status === "approved"}
                      >
                        {t("Reject")}
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          <PdfPopupViewer
            pdfFiles={pdfFiles}
            showModal={showModal}
            onClose={() => handleClose()}
            t={t}
          />
          <ApprovalDialog
            isOpen={isCancelDialogOpen}
            onClose={() => setIsCancelDialogOpen(false)}
            action="cancel"
            onSubmit={handleCancelOrderSubmit}
            customerName={formData.selectedCustomerName}
            title={t("Cancel Order")}
            subtitle={t(`Are you sure you want to cancel this order? Please provide a reason for cancellation.`)}
            placeholder={t("Enter reason for cancellation...")}
            pageType="order" // Important: specifies this is for order page
          />
        </div>
      )
      }
    </Sidebar >
  );
}
export default OrderDetails;
